/*
  * Common global custom js file with functions/methods
  * Fine Jewelry
  * Vow, Design files
  * Helper functions
*/
var apiVersion = "/admin/api/2023-04/";  /* Old-Version: "/admin/api/2020-01/"; */
var originalLeadTimeMsg;

localStorage.removeItem('productStockInfo')
$("body").css("overflow", "visible");

$(document).ready(function () {
  var updateDropdownValues = currentProductJson ? currentProductJson.tags.filter(s => s.startsWith('update-dropdown-values: ')).map(s => s.replace('update-dropdown-values: ', '')) : [];
  if(updateDropdownValues && updateDropdownValues.length !== 0){
    updateDropdwonValuesInUI(updateDropdownValues[0]);
  }
  /* Redirecting the Diamond product to Ring Builder Page */
  if(currentProductJson?.type === 'Diamond' && pageType === 'product') window.location.href = ringBuilderPageUrl
  
  $(".acordian__link").on("click", function() {
    var $button = $(this).find("button.select_diamond");
    var currentState = $button.attr("aria-expanded") === "true";
    $(this).find(".priceSortIcon").toggleClass("priceSortIcon-rotate")
    $(this).parent().next().toggleClass("acordian-body-hide")
    $button.attr("aria-expanded", !currentState);
  })
  $(".checkoutNowButton").on("click", function (){
    isCheckoutNowButtonPressed = true;
  })
  $(".ProductForm__AddToCart").click(function () {
    isCheckoutNowButtonPressed = false;
  })
  /* Check VIP & VVIP Visitior Via URL Params and saving the data to local storage */
  var checkVisitorCustomer = getParameterByName("sale")
  var isVipUser = "ACZMYQHIYXUHIPA";   //unique param for VIP visitor
  var isVVipUser = "LQVSHERFEPJLFHU";  // unique param for VVIP visitor
  /* Saving Visitors Info to Localstorage :For VIP User*/
  if (checkVisitorCustomer && checkVisitorCustomer.indexOf(isVipUser) !== -1) {
    localStorage.setItem("setVisitingCustomer", getVIPParam)
  }
  /* Saving Visitors Info to Localstorage :For VVIP User*/
  if (checkVisitorCustomer && checkVisitorCustomer.indexOf(isVVipUser) !== -1) {
    localStorage.setItem("setVisitingCustomer", getVVIPParam)
  }
  /* Locked Private Sale: Check VIP User */
  if (checkVIPUser && checkVIPUser === true && showVIPPrivateSale && showVIPPrivateSale === true) {
    localStorage.setItem("setVisitingCustomerPrivateSale", getVIPParamPrivateSale)
  }
  /* Locked Private Sale: Check VVIP User */
  if (checkVVIPUser && checkVVIPUser === true && showVVIPPrivateSale && showVVIPPrivateSale === true) {
    localStorage.setItem("setVisitingCustomerPrivateSale", getVVIPParamPrivateSale)
  }

  $("a.print-gift-link").click(function () {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Special Callout',
      eventAction: 'Downloaded the Something Special pdf',
      eventLabel: 'Special Callout',
      hitCallback: function (g) {
      }
    });
  });
  
  $(".ProductItem__Price .money").each(function (index) {
    var currentPrice = $(this).text()
    // UI display adjustment
    if (currentPrice.endsWith(".00")) {
      currentPrice = currentPrice.replace(".00", "")
      $(this).text(currentPrice)
    }
  });
  $('.HorizontalList,.Header__Logo').hover(function () {
    $('.Popover').attr('aria-hidden', true)
    $("body").addClass("is-rc-close")
    $("body").removeClass("noscroll")
    $("html").removeClass("no-scroll")
    $('.ProductForm__Item').attr('aria-expanded', 'false')
  })
  // Already diamond popup modal close
  $(".already-diamond-popup-close").on('click', function () {
    $("#already-diamond-popup").removeClass("open")
  })
  
  createDiamondUrl = (diamondId, type) => {
    var diamondUrl = ""
    var siteHref = window.location.href
    var hasDiamondCert = getParameterByName("did")
    diamondUrl = updateQueryStringParameter(siteHref, 'did', diamondId)
    diamondUrl = updateQueryStringParameter(diamondUrl, 'page', 1)
  
    var linkRequest = {
      destination: diamondUrl,
      domain: { fullName: "rebrand.ly" }
    }
  
    var requestHeaders = {
      "Content-Type": "application/json",
      "apikey": "4cbb207efc6848009e0f525952cd114e",
    }
  
    if (type === 'mailTo') {
      $.ajax({
        url: "https://api.rebrandly.com/v1/links",
        type: "post",
        data: JSON.stringify(linkRequest),
        headers: requestHeaders,
        dataType: "json",
        success: (link) => {
          var diamondUrlBody = encodeURI(`I found the perfect diamond for my engagement ring on VOW by Ring Concierge, check out the details here: https://${link.shortUrl} `)
          var mailToUrl = `mailto:someone@example.com?subject=${encodeURI('Check out this diamond I found on Ring Concierge')}&body=${diamondUrlBody}`
          window.open(mailToUrl);
        }
      });
    }
    if (type === 'clipboard') {
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(diamondUrl).select();
      document.execCommand("copy");
      showErrorMessage("Link Copied")
      $temp.remove();
    }
  }
  
  // Handler for .ready() called.
  $('#designFileFormClose').click(function () {
    var abandonObj = {
      "/pages/start": "Select Diamond Shape - Cancelled",
      "/pages/build": "Select Setting - Cancelled",
      "/pages/diamond-details": "Diamond Details - Cancelled",
      "/pages/share": "Share Your Design - Cancelled"
    }
    ga('send', {
      hitType: 'event',
      eventCategory: 'Design file',
      eventAction: abandonObj[window.location.pathname],
      eventLabel: abandonObj[window.location.pathname],
      hitCallback: function (g) {
      }
    });
  })
  
  // Set URI first part before query parameter
  if (window.location.search.includes("utm_source=designfile")) {
    localStorage.setItem("designFileSource", window.location.href.split("?variant")[0])
  }
  
  $('#openEngravingModal').click(() => {
    if (localStorage.getItem("selectingDiamondFor") && localStorage.getItem("selectingDiamondFor").includes(localStorage.getItem("designFileSource"))) {
      ga('send', {
        hitType: 'event',
        eventCategory: 'Design file',
        eventAction: "Design File Product Details",
        eventLabel: "Design File Product Details",
        hitCallback: function (g) {
        }
      });
    }
  })
  
  var ghJidSet = getParameterByName('gh_jid', window.location.href);
  if (ghJidSet) {
    jQuery(".hideifghjid").css("display", "none")
    jQuery("#section-footer").css("margin-top", "0")
  }
  
  // Closing the mobile drawer automatically if wishlist model is opened
  $("a[href='#swym-wishlist']").on("click", function () {
    jQuery("#sidebar-menu").attr("aria-hidden", true)
  })

  /* When the user gets on search result page, run this run to show Sale Price on that page... */
  showSalePriceOnSearchBar()

  // Get all elements with class "show-hover-img"
  var hoverImgs = document.querySelectorAll('.show-hover-img');
  hoverImgs.forEach(hoverImg => {
    hoverImg.addEventListener('mouseover', function() {
      this.setAttribute('aria-hidden', 'false');
    });
    hoverImg.addEventListener('mouseout', function() {
      this.setAttribute('aria-hidden', 'true');
    });
  });
})

localStorage.removeItem('productStockInfo')
$("body").css("overflow", "visible");

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})
var fraction = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

var formatPriceFunc = (price) => {
  price = price.toString();  // Convert the price to a string to ensure we're working with a string value.
  price = price.replace(/\.00$/, ''); // Use a regular expression to remove trailing ".00" and preserve other decimals.
  return price;
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\s+/g, " "));
}

function getQueryParams(params) {
  var href = decodeURIComponent((window.location.href).replace(/\+/g, '%20'));
  var reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i');
  var queryString = reg.exec(href);
  return queryString ? queryString[1] : null;
}

Array.prototype.max = function () {
  return Math.max.apply(null, this);
};

Array.prototype.min = function () {
  return Math.min.apply(null, this);
};

function commafy(num) {
  var str = num.toString().split('.');
  if (str[0].length >= 4) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  if (str[1] && str[1].length >= 4) {
    str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }
  return str.join('.');
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

var moneyFormat = wNumb({
  decimals: 0,
  thousand: ',',
  prefix: '$'
});

var caratFormat = wNumb({
  mark: '.',
  thousand: ',',
  decimals: 2,
});

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    return uri + separator + key + "=" + value;
  }
}
/** * Select Diamond JS code: END * **/

function updateProductPrice(p) {
  var shopifyFinalPrice = 0
  if (p % 1 === 0) {
    shopifyFinalPrice = fraction.format(p);
  } else {
    shopifyFinalPrice = formatter.format(p);
  }
  
  /* Implementation for Bespoke Pre Cart */
  var finalTotalPricePreCart = 0
  var diamondPriceText = $('#preCartDiamondPrice').text();
  var settingPriceText = $('#actualSettingprice').text();
  // Remove the dollar sign and commas from the prices
  var diamondPrice = parseFloat(diamondPriceText.replace('$', '').replace(/,/g, ''));
  var settingPrice = parseFloat(settingPriceText.replace('$', '').replace(/,/g, ''));
  finalTotalPricePreCart = diamondPrice + settingPrice;
  if (finalTotalPricePreCart % 1 === 0) {
    finalTotalPricePreCart = fraction.format(finalTotalPricePreCart);
  } else {
    finalTotalPricePreCart = formatter.format(finalTotalPricePreCart);
  }
  finalTotalPricePreCart && finalTotalPricePreCart !== 0 ? finalTotalPricePreCart : shopifyFinalPrice
  
  // Appending Final Calculated Price
  $("#preCartTotalProductPrice").text(finalTotalPricePreCart)
  
  // $("#openEngravingModal span").text(`Add to cart ${shopifyFinalPrice}`)
  $("#openEngravingModal span").text(`Add to bag`)
  $(".engravingModal_btn").find('.markedPopUpPrice').text(`${shopifyFinalPrice}`)
  affirm.ui.ready(function () {
    $("#affirm_product").attr('data-amount', (p * 100));
    affirm.ui.refresh();
  });
}

/** * Select Diamond display formatted sale price * **/
function updateMarkedUpPricePrice(p) {
  var shopifyFinalPrice = 0
  if (p % 1 === 0) {
    shopifyFinalPrice = fraction.format(p);
  } else {
    shopifyFinalPrice = formatter.format(p);
  }
  $(".markedUpPrice").text(shopifyFinalPrice)
  updatePriceThreeStepProcess(shopifyFinalPrice);
}

/*** General/Common conversions ***/
function removeChar(name) {
  return name && name !== '' ? (name.replace(/\s/g, '')) : ''
}

function removeCharWithLowerCase(name) {
  return name && name !== '' ? (name.replace(/\s/g, '')).toLowerCase() : ''
}

function removeDoller(price) {
  return parseFloat(`${price}`.replace(/\s/g, '').replace('$', '').replace(',', ''))
}

function productPrice(price) {
  return parseFloat(price / 100)
}

/* Common function to call API Calls */
// diamondApiUrl added on 18 Nov 2024
function commonApiCalls(data, cb) {
  fetch(diamondApiUrl + '/getshopifyapi', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then((data) => {
    cb(data)
  })
}

/* Common Function to call Klaviyo Email's Capture */
function commonKlaviyoCallscapture(data, cb) {
  try {
    fetch(portalApiUrl + '/shopify_capture_klaviyo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then((data) => {
      cb(data)
    })
  } catch (error) {
    console.log('An error occurred:', error);
  }
}

function showToasterPopup(message) {
  if (message !== '') {
    $(".toast__content").text(message)
    $(".toast__cell").removeClass("close")
  } else {
    $(".toast__cell").addClass("close")
    $(".toast__content").text('')
  }
  $(".toast__close").on('click', () => {
    $(".toast__cell").addClass("close")
    $(".toast__content").text('')
  })
}

function playFile() {
  var video = $("#videoID");
  if (video.length && video[0].play()) {
    video[0].load();
    video[0].play();
  }
};

function closedAction() {
  $(".close-modal-popup").on('click', function (event) {
    if ($("#out_off_stack_product").hasClass('open')) {
      $("#out_off_stack_product").removeClass("open")
      $("body,html").removeClass("modal-window-open");
    }
    if ($("#product_info").hasClass('open')) {
      $("#product_info").removeClass("open")
      $(".modal-window-body-cart").find(".modal-window-content").html('')
      var url = window.location.href.split('?')[0];
      var prevUrl;
      if (window.history && currentProductJson && currentProductJson.id != '7016921235544') {
        window.history.pushState({ prevUrl: window.location.href }, null, url);
      }
      if (window.history && !currentProductJson) {
        window.history.pushState({ prevUrl: window.location.href }, null, url);
      }
      $("body,html").removeClass("modal-window-open");
    }
  })
  $(".Drawer__Close").on('click', function () {
    if ($("#sidebar-cart-drawer").attr('aria-hidden') === 'false') {
      $("#sidebar-cart-drawer").attr("aria-hidden", "true").removeAttr('tabindex', '-1');
      $(".PageOverlay").removeClass("is-visible");
    }
  })
}

(function ($) {
  closedAction();
});

function getProductFromShopify(handle, cb) {
  commonApiCalls({
    apiUrl: apiUrlPath + apiVersion + "products.json?handle=" + handle,
    method: 'GET'
  }, (data) => {
    if (data && data.products && data.products.length > 0) {
      var prod = data.products[0]
      cb(null, prod)
    } else {
      cb(null, null)
    }
  })
}

function changeSliderArrows() {
  var pre = '<svg class="Icon Icon--arrow-left" role="presentation" viewBox="0 0 11 21"><polyline fill="none" stroke="currentColor" points="10.5 0.5 0.5 10.5 10.5 20.5" stroke-width="1.25"></polyline></svg>';
  var next = '<svg class="Icon Icon--arrow-right" role="presentation" viewBox="0 0 11 21"><polyline fill="none" stroke="currentColor" points="0.5 0.5 10.5 10.5 0.5 20.5" stroke-width="1.25"></polyline></svg>';
  if (currentProductTemplate && currentProductTemplate === 'vow.engagement.rings') {
    $('.Product__Slideshow-vow').find('.flickity-prev-next-button.previous').addClass('RoundButton').html(pre)
    $('.Product__Slideshow-vow').find('.flickity-prev-next-button.next').addClass('RoundButton').html(next)
  } 
}

/** * Custom message display in 3 sec duration * **/
function showErrorMessage(message) {
  showToasterPopup(message);
  $(".toast__content").attr('aria-live', 'polite').attr('role', 'alert');
  setTimeout(() => {
    showToasterPopup('');
  }, 3000)
}

function deleteProduct(productId) {
  var body = {
    apiUrl: apiUrlPath + apiVersion + "products/" + productId + ".json",
    method: 'DELETE'
  }
  commonApiCalls(body, (data) => {
  })
}

function mobileslider(item) {
  var pid = $(item).attr('pid')
  var href = $(".product_redirecturl" + pid).attr("href");
  window.location.href = href;
}

function getIcons(action) {
  var icons = '';
  if (iconsWithName.hasOwnProperty(action)) {
    icons = iconsWithName[action]
  }
  return icons;
}

function VOW_variant_select_images(productId, products, selectedVariantId) {
  if (products) {
    var images = []
    if (products !== '') {
      images = products.media;
    }
    vowloadingImages(images, productId, selectedVariantId)
  }
}

function vowloadingImages(images, productId, selectedVariantId) {
  var carouselImage = false
  if ($('.carousel.MobSlider' + productId).length) {
    carouselImage = true
  }
  var countImage = $(".AspectRatio").find(".img" + productId).length
  if (images && images.length) {
    var variantImage = $.map(images, vari => {
      if (vari.alt && vari.alt != null && vari.alt != '') {
        if (vari.alt.indexOf(String(selectedVariantId)) !== -1) {
          return vari
        }
      }
    })
    if (variantImage && variantImage.length) {
      var newArray = variantImage
      $.map(newArray, (v, i) => {
        if (i < countImage) {
          var selected = i === 0 ? 'is-selected' : ''
          $(".AspectRatio").find(".img" + productId + ':eq(' + i + ')').addClass(`${selected}`).attr('data-src', v.src).attr('src', v.src).attr('data-image-id', v.alt).attr('alt', v.alt)
        }
        if (carouselImage && i < countImage) {
          $(".carousel.MobSlider" + productId).find('.flickity-slider').find('img:eq(' + i + ')').attr('src', v.src)
        }
      })
    } else {
      showVowProductImages(productId, countImage, carouselImage)
    }
  } else {
    showVowProductImages(productId, countImage, carouselImage)
  }
  changeSliderArrows();
}

function showVowProductImages(productId, countImage, carouselImage) {
  var pro = $.map(products, v => { if (String(v.id) === String(productId)) { return v; } })
  if (pro && pro[0] && pro[0].length) {
    $.map(pro[0].media, (img, i) => {
      if (i < countImage) {
        var selected = i === 0 ? 'is-selected' : ''
        $(".AspectRatio").find(".img" + productId + ':eq(' + i + ')').addClass(`${selected}`).attr('data-src', img.src).attr('src', img.src).attr('data-image-id', img.id).attr('alt', img.alt)
      }
      if (carouselImage && i < countImage) $(".carousel.MobSlider" + productId).find('.flickity-slider').find('img:eq(' + i + ')').attr('src', img.src)
    })
  }
}

function setDefaultVariantsInGrid() {
  $(".Grid__Cell").each(function (index) {  
    let diamondText = $(this).find(".ProductItem__Title>a").text().trim();
    let diamond = null;
    let metal = null;
    
    const diamondFound = diamondMetalMappings.find(item => item.name === diamondText);
    
    if (diamondFound) {
      diamond = getDiamondOtherNames(diamondFound.diamond);
      metal = getMetalOtherNames(diamondFound.metal);
    } else {
      variantIdData = diamondText;
    }
    if (diamond && diamond.length > 0) {
      for (var i = 0; i < diamond.length; i++) {
        if ($('li[itemid="' + diamond[i].toLowerCase() + '"]>a').length > 0) $(this).find('li[itemid="' + diamond[i].toLowerCase() + '"]>a').trigger("click")
      }
    }
    if (metal && metal.length > 0) {
      for (var i = 0; i < metal.length; i++) {
        // In VOW there was itemid
        if ($('li[itemid="' + metal[i] + '"]>a').length > 0) $(this).find('li[itemid="' + metal[i] + '"]>a').trigger("click")
      }
    }
  })
}

// Same function is on api also
function requestParameterByDiamondName(name) {
  var json = {
    symmetry_from: "Excellent",
    color_from: "D",
    polish_from: "Excellent",
    polish_to: "Good",
    clarity_from: "IF",
    clarity_to: "SI2",
    fluorescence_intensities: ["Medium", "Faint", "None"]
  }
  // Diamond 1
  if (name == "Round") {
    json.shapes = ['Round']
    json.symmetry_to = "Excellent"
    json.polish_to = "Excellent"
    json.cut_from = "Excellent"
    json.cut_to = "Excellent"
    json.color_to = "J"
  }
  // Diamond 2
  else if (name == "Oval") {
    json.shapes = ['Oval']
    json.symmetry_to = "Good"
    json.color_to = "J"
  }
  // Diamond 3
  else if (name == "Cushion") {
    json.shapes = ['Cushion']
    json.symmetry_to = "Good"
    json.color_to = "J"
  }
  // Diamond 4
  else if (name == "Pear") {
    json.shapes = ['Pear']
    json.symmetry_to = "Good"
    json.color_to = "J"
  }
  // Diamond 5
  else if (name == "Radiant") {
    json.shapes = ['Radiant']
    json.symmetry_to = "Good"
    json.color_to = "J"
  }
  // Diamond 6
  else if (name == "Emerald") {
    json.shapes = ['Emerald']
    json.symmetry_to = "Good"
    json.clarity_to = "VS2"
    json.color_to = "J"
  }
  // Diamond 7
  else if (name === 'Old Cut Round' || name === 'Antique-Style Round') {
    json.shapes = ['Old Cut Round']
    json.symmetry_to = "Fair"
    json.color_to = "K"
  }
  // Diamond 8
  else if (name === 'Old Cut Cushion' || name === 'Antique-Style Cushion') {
    json.shapes = ['Old Cut Cushion']
    json.symmetry_to = "Fair"
    json.color_to = "K"
  }
  // Diamond 9
  else if (name === 'Princess') {
    json.shapes = ['Princess']
    json.symmetry_to = "Good"
    json.color_to = "J"
  }
  // Diamond 10  
  else if (name === 'Marquise') {
    json.shapes = ['Marquise']
    json.symmetry_to = "Good"
    json.color_to = "J"
  }  
  else {
    return null
  }
  return json
}

$('.slide-relative').mouseover(function () {
  dotSelected(this, 0, 1)
});
$('.slide-relative').mouseout(function () {
  dotSelected(this, 1, 0)
});

function dotSelected(evThis, x, z) {
  $(evThis).find(".flickity-page-dots").find("li:eq(" + x + ")").removeClass('is-selected')
  $(evThis).find(".flickity-page-dots").find("li:eq(" + z + ")").addClass('is-selected')
}

/**
* This function returns product from vow collection json
* @params
* products = json of product which has to be iterate i.e collection
* productId = The id of the product which has to be get
**/
function getProductInfoFromCollection(products, productId) {
  if (products && productId) {
    var selectedProduct = {}
    products.map(function (products, i) {
      if (parseInt(products.id) == parseInt(productId)) {
        selectedProduct = products
      }
    })
    return selectedProduct
  } else {
    return null
  }
}

/**
* This function returns variant info from vow product json
* @params
* product = json of product which has to be iterate
* diamond = diamond name which is actually option1 of product json
* metal = metal name which is actually option2 of product json
* design = design which is actually option3 of product json
**/
function getVowProductVariantInfo(product, diamond = null, metal = null, design = null) {
  var variantInfo = null
  if (product instanceof Object) {
    var metalOtherNames = getMetalOtherNames(metal)
    var diamondOtherNames = getDiamondOtherNames(diamond)
    if (diamond === 'Antique Style Cushion') diamondOtherNames = 'Antique-Style Cushion'
    product.variants.map(function (v, i) {
      if (v.option3){
        if (diamondOtherNames.indexOf(v.option1) !== -1 && metalOtherNames.indexOf(v.option2) !== -1 && v.option3 == design) {
          variantInfo = v
        }
      } else {
        if (diamondOtherNames.indexOf(v.option1) !== -1 && metalOtherNames.indexOf(v.option2) !== -1) {
          variantInfo = v
        }
      }
    })
    return variantInfo
  }
  return variantInfo
}

function getProductDefaultMetalAndDiamond(productName) {
  var diamondText = productName
  var diamond = null
  var metal = null
  if (diamondText) {
    if (diamondText == 'Madison') {
      diamond = 'oval'
      metal = 'YellowGold'
    }
    else if (diamondText == 'Lexington') {
      diamond = 'round'
      metal = 'Platinum'
    }
    else if (diamondText == 'Mercer') {
      diamond = 'round'
      metal = 'YellowGold'
    }
    else if (diamondText == 'Uptown') {
      diamond = 'emerald'
      metal = 'Platinum'
    }
    else if (diamondText == 'Waverly') {
      diamond = 'oval'
      metal = 'YellowGold'
    }
    else if (diamondText == 'Gramercy') {
      diamond = 'round'
      metal = 'Platinum'
    }
    else if (diamondText == 'Delancey') {
      diamond = 'old cut round'
      metal = 'Platinum'
    }
    else if (diamondText == 'Essex') {
      diamond = 'oval'
      metal = 'YellowGold'
    }
    else if (diamondText == 'Tribeca') {
      diamond = 'round'
      metal = 'YellowGold'
    }
    else if (diamondText == 'Bowery') {
      diamond = 'round'
      metal = 'YellowGold'
    }
    else if (diamondText == 'Lenox') {
      diamond = 'old cut round'
      metal = 'YellowGold'
    }
    else if (diamondText == 'Layette') {
      diamond = 'Cushion'
      metal = 'Platinum'
    }
    else if (diamondText == 'Park') {
      diamond = 'old cut cushion'
      metal = 'Platinum'
    }
    else {
      variantIdData = diamondText
    }

  }
  return { diamond, metal }
}

function getDiamondType() {
  var diamondType = getParameterByName("diamondType", window.location.href)
  if (diamondType) {
    if (diamondType === "Round" || diamondType === "Pear" || diamondType === "Oval" || diamondType === "Radiant" || diamondType === "Emerald" || diamondType === "Cushion") {
      return diamondType;
    } else {
      return diamondType;
    }
  }
  else {
    return "Round"
  }
}

function removeVowLocalstorageItems() {
  localStorage.removeItem("_raw_diamond_info")
  localStorage.removeItem('seletedDiamond')
  localStorage.removeItem("get_diamond_total_sale_price")
  localStorage.removeItem('select_main_product_data')  
  localStorage.removeItem('selectedDiamondCompleteData')
  localStorage.removeItem('selectedSettingInfo')
  threeStepProcess();
}

/** * Common js for select diamond and compare diamond * **/
function redirectToProductDetailPage(diamondShape) {
  var grabSelectedProductInfo = localStorage.getItem("select_main_product_data")
  var selectedProductInfo = JSON.parse(grabSelectedProductInfo)
  var getProductHandle = "";
  if (selectedProductInfo){
    getProductHandle = selectedProductInfo.getProductHandle
  }
  var productHandle = getParameterByName("productHandle") || getProductHandle
  if (productHandle) {
    fetch("/collections/all/products/" + productHandle + ".json", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((data) => {
      vowProduct = data.product
      return vowProduct
    })
    .then(function (vowProduct) {
      // Getting parameters by name
      var selectedMetal= getParameterByName("metal")
      var decodedMetal = decodeURIComponent(selectedMetal);
      var metal = decodedMetal.replace(/\s+/g, '');
      var diamondTag = getParameterByName("diamondLabType")
      var diamondType = diamondShape ? diamondShape : getParameterByName("diamondType")
      var variantId = getParameterByName("variantId")
      var grabRingSize = getParameterByName("ringSize") || selectedProductInfo.getSelectedRingSize
      var grabDesignDetails = getParameterByName("designDetails")
      var selectDiamondFirstInfo = getParameterByName("selectDiamondFirst")
      var preCartStatus = getParameterByName("preCart")
      var productHandleDesignDetail = "Original Design"
      var grabRawDiamondInfo = localStorage.getItem("_raw_diamond_info");
      var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
      // Generating String
      redirectString = `/collections/${js_vow_collection_page}/products/${productHandle}?deleteselecteddiamond=false&`
      if (metal) redirectString += "&metal=" + metal
      if (grabRingSize) redirectString += "&ringSize=" + grabRingSize
      if (grabDesignDetails) redirectString += "&designDetails=" + grabDesignDetails
      if (productHandle) redirectString += "&productHandle=" + productHandle
      if (diamondType) {
        if (diamondType === 'Antique Style Cushion') diamondType = 'Antique-Style Cushion'
        if (diamondType === 'Antique Style Round') diamondType = 'Antique-Style Round'
        redirectString += "&diamondType=" + diamondType
      }
      if (diamondTag) {
        redirectString += "&diamondTag=" + diamondTag
      } else {
        redirectString += "&diamondTag=natural"
      }
      if (grabRawDiamondInfo && preCartStatus !== 'false') {
        redirectString += "&preCart=true"
      }
      if(selectDiamondFirstInfo) {
        redirectString += "&selectDiamondFirst=true"
      } 
      if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true') {
        redirectString += "&startwithsetting=true"
      } 
      /** * Getting the product metal and design detail from previous metal * **/
      if (variantId) {
        vowProduct.variants.map(function (data, i) {
          if (data.id == variantId) {
            productHandleDesignDetail = data.option3
            if (!metal) {
              metal = data.option2
            }
          }
        })
      }
      if (metal && diamondType && vowProduct) {
        var variantInfo = getVowProductVariantInfo(vowProduct, diamondType, metal, productHandleDesignDetail)
        if (variantInfo) redirectString += "&variant=" + variantInfo.id
      }
     window.location.href = redirectString
    })
  } else {
    console.log("Product handle is empty")
    var diamondType = diamondShape ? diamondShape.charAt(0).toUpperCase() + diamondShape.slice(1) : getParameterByName("diamondType")
    if (diamondType) {
      if(diamondType === "Antique-Style Cushion" || diamondType === "Antique Style Cushion" || diamondType === 'antiquestylecushion') diamondType = 'OldMine'
      if(diamondType === "Antique-Style Round" || diamondType === "Antique Style Round" || diamondType === 'antiquestyleround' || diamondType === 'antique-styleround') diamondType = 'European'
      window.location.href = `/collections/${js_vow_collection_page}?dp=${diamondType}`
    } else {
      window.location.href = `/collections/${js_vow_collection_page}`
    }
  }
}

function callApiCallBack(url, data, cb) {
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then((data) => {
    cb(data.response.body)
  })
}

/** * Diamond abbreviation * **/
function shapeId(name) {
  if (name == "Round") {
    return 'RD'
  } else if (name == "Oval") {
    return 'OV'
  } else if (name == "Pear") {
    return 'PS'
  } else if (name == "Radiant") {
    return 'RA'
  } else if (name == "Cushion") {
    return 'CU'
  } else if (name == "Emerald") {
    return 'EC'
  } else if (name == "European" || name == "Old Cut Round" || name === 'Antique-Style Round' || name === 'Antique Style Round') {
    return 'OE'
  } else if (name == "Old Mine" || name == "Old Cut Cushion" || name === 'Antique-Style Cushion' || name === 'Antique Style Cushion') {
    return 'OM'
  } else if (name == "Princess" || name == "princess") {
    return 'PR'
  } else {
    return name
  }
}

function vendorId(name) {
  if (name == "68119") {
    return 'RR'
  } else if (name == "56068") {
    return 'JR'
  } else if (name == "21684") {
    return 'RDI'
  } else if (name == "25333") {
    return 'HZ'
  } else if (name == "103644") {
    return 'RC'
  } else if (name == "66863") {
    return 'OM'
  } else if (name == "111935") {
    return 'DR'
  } else if (name == "117373") {
    return 'NK'
  } else if (name == "61666") {
    return 'BL'
  } else if (name == "80926") {
    return 'BC'
  } else if (name == "19029") {
    return 'DG'
  } else if (name == "100") {
    return 'SL'
  } else if (name == "101") {
    return 'GR'
  } else if (name == "102") {
    return 'FN'
  } else if (name == "106054") {
    return 'MD'
  } else if (name == "100332") {
    return 'Aarush'
  } else if (name == "1643772") {
    return 'EM'
  } else if (name == "1643001") {
    return 'EL'
  } else if (name) {
    return name
  } else {
    return null
  }
}

/** * Hide loader * **/
function hideFrameLoader(elm) {
  setTimeout(function () {
    $(`.framesloader${elm}`).fadeOut('slow', function () {
      $(`.framesloader${elm}`).remove();
    });
  }, 100);
}

function clearVowProductsAndSaveDiamond() {
  var vow_items_in_cart = localStorage.getItem("_vow_item_cart");
  var clicked_button_cert_id = localStorage.getItem("_clicked_button_cert_id");
  if (vow_items_in_cart) {
    var vowItems = JSON.parse(vow_items_in_cart)
    var clickedButtonCertId = JSON.parse(clicked_button_cert_id)

    // if vow items length is greater than 0
    if (vowItems.length > 0) {
      var updateVowItems = {}
      vowItems.length > 0 && vowItems.forEach((item) => {
        updateVowItems[item.id] = 0
      })
      $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: { updates: updateVowItems },
        dataType: 'json',
        success: function (data) {
          // Clearing the localstorage items
          localStorage.removeItem("_vow_item_cart")
          localStorage.removeItem("_clicked_button_cert_id")
          $(`.already-diamond-popup-close`).trigger("click")
          $(`button.vow-btn-dark[data-cert_num="${clickedButtonCertId}"]`).trigger("click")
        },
        error: function (XMLHttpRequest, textStatus) {
          alert(textStatus)
        }
      })
    }
  }
}

/*** Directly getting the store all products so that No server involved ***/
function getProductByHandle(productHandle) {
  return fetch("/collections/all/products/" + productHandle + ".json", {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
}

jQuery.fn.serializeObject = function () {
  var o = {};
  var a = this.serializeArray();
  $.each(a, function () {
    if (o[this.name] !== undefined) {
      if (!o[this.name].push) o[this.name] = [o[this.name]];
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  return o;
}

/* Setting word counts */
function setWordCounts() {
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (data) {
      for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].product_id == '7166127210584') jQuery.post('/cart/change.js', { quantity: 0, id: data.items[i].id })
        if (data.items[i].properties && data.items[i].properties.Customization && data.items[i].properties._Customization_Required != undefined) {
          $(".siteLoader").show()
          var variantId = data.items[i].variant_id;
          var getWordCount = data.items[i].properties._Customization_Word_Count;
          var _associated_unique_key = data.items[i].properties["_associated_unique_key"]
          var customizationInputBox = $('#Customization' + variantId+_associated_unique_key);
          for (var j = 0; j < data.items[i].options_with_values.length; j++) {
            if (data.items[i].options_with_values[j].name == "Letter Count" || data.items[i].properties._cTag == 'Yes') customizationInputBox.attr('maxlength', getWordCount)
          }
          var grabMaxLength = customizationInputBox.attr("maxlength");
          if (customizationInputBox.val().length < getWordCount && data.items[i].properties._cTag != 'Yes' && typeof grabMaxLength !== 'undefined' && grabMaxLength !== false) {
            jQuery('.Cart__Checkout').attr('disabled', 'disabled')
            jQuery('#Customization' + variantId+_associated_unique_key).addClass('required')
            jQuery('#custom_error_message_' + variantId).css('display', 'block').text('Please enter correct letter counts ' + '(' + getWordCount + ')');
            timeDelay
          } else {
            jQuery('#custom_error_message' + variantId).css('display', 'none');
            timeDelay
          }
        } else {
          timeDelay();
        }
      }
    }
  })
}

function timeDelay(){
  setTimeout(() => {
    $("input").prop('disabled', false);
  }, 2000)
  $(".siteLoader").hide()
}

/*** This function is important to manage any associated Gift Wrap product of any RCFJ product ***/
function getAssociatedGiftWrapItemKey(cartData, variantId) {
  var giftWrapProduct = null
  if (cartData.items && cartData.items.length > 0) {
    cartData.items.map(v => {
      if (v.properties && v.properties._associated_variant_id == variantId) giftWrapProduct = v
    })
  }
  return giftWrapProduct
}

/*** This function is important to manage any associated Complimentory Gift Wrap product of any RCFJ product ***/
function getAssociatedcomplimentaryItemKey(cartData, variantId) {
  var complimentaryProduct = null
  if (cartData.items && cartData.items.length > 0) {
    cartData.items.map(v => {
      if (v.properties && v.properties._complimentary_associated_variant_id == variantId) complimentaryProduct = v
    })
  }
  return complimentaryProduct
}

/*** This function is important to manage any associated Gift Wrap product of any RCFJ product ***/
function getAssociatedCustomLengthItemKey(cartData, variantId) {
  var giftWrapProduct = null
  if (cartData.items && cartData.items.length > 0) {
    cartData.items.map(v => {
      if (v.properties && v.properties._sccl_associated_variant_id == variantId) giftWrapProduct = v
    })
  }
  return giftWrapProduct
}

/****************************** /GIFT WRAP **********************************************/
/*** This function will count the number of type and remaing character in textarea ***/
function textCounter(field) {
  var complimentaryText = jQuery(field).val()
  var variantId = jQuery(field).attr("data-variantid")
  var _associated_unique_key = jQuery(field).attr("data-unique-key")
  jQuery('#complimentarywrapTextarea' + variantId+_associated_unique_key).html(complimentaryText)
  var maxlimit = jQuery(field).attr("maxlength")
  if (field.value.length > maxlimit) {
    field.value = field.value.substring(0, maxlimit);
    return false;
  } else {
    var typedChar = maxlimit - field.value.length;
    jQuery(field).next().find("span").text(typedChar)
  }
}

$('#complimentarywrapCheckbox').on('click', function () {
  if (!$('#complimentarywrapCheckbox').is(':checked')) jQuery('.errormsg').text('').removeClass('open').addClass('hide')
});
  
function appendFontFamily() {
  var getCount = $('#customization').val().length;
  var getValue = $('#customization').val();
  var getFontFamily = $('.get_variant_font_family').text();
  $('#customization_count').val(getCount);
  $('#previewText').text(getValue);
  $('#previewText').css('font-family', getFontFamily.replaceAll(/\s/g, ''))
}

/* Close Modal Popup */
$(".modal-close-icon", 'body').on("click", function () {
  closedAction();
});

/* Formatting price by replacing zero with space */
var formatPriceFunc = (price) => {
  price = price.toString();
  price = price.replace(/\.00$/, '');
  return price;
}

/* Enabling Mini-Cart on hover after clicking on close popover */
$(".vow-modal-close").click(function () {
  $('#js-cart-drawer').css("pointer-events", "inherit");
})

/**
* Fetch Custom stone variants Array function
* Tag used: custom-stone-count, custom-stone-count-2, custom-stone-count-band
**/
var customStoneDropDownOptions = [];
var customStoneDropDownOptionsTwo = [];
var customStoneDropDownOptionBand = [];
function customStoneArray(customStoneTag) {
  getProductByHandle(customStoneTag)
    .then(function (customStoneCountGhostProduct) {
      var optionsArr = []
      for (var i = 0; i < customStoneCountGhostProduct.product.variants.length; i++) {
        var filteredNames = $(customStoneCountGhostProduct.product.images).filter(function (idx) {
          return customStoneCountGhostProduct.product.images[idx].id === customStoneCountGhostProduct.product.variants[i].image_id
        });
        $(filteredNames).each(function () {
          customStoneCountGhostProduct.product.variants[i].imageUrl = this.src;
        })
      }
      return customStoneCountGhostProduct.product.variants;
    }).then(function (options) {
      if (customStoneTag == 'custom-stone-count') {
        customStoneDropDownOptions = options
        return customStoneDropDownOptions
      } else if (customStoneTag == 'custom-stone-count-2') {
        customStoneDropDownOptionsTwo = options
        return customStoneDropDownOptionsTwo
      } else if (customStoneTag == 'custom-stone-count-band') {
        customStoneDropDownOptionBand = options
        return customStoneDropDownOptionBand
      }
    })
}

function customStoneOptions(property, index, lineItem) {
  var dropdownOption = customStoneDropDownOptions;
  if (lineItem.properties && lineItem.properties._customStoneTag === "custom-stone-count-2") dropdownOption = customStoneDropDownOptionsTwo
  if (lineItem.properties && lineItem.properties._customStoneTag === "custom-stone-count-band") dropdownOption = customStoneDropDownOptionBand

  if (property && property.length > 1 && dropdownOption.length) {
    var variantId = property[1]
    var key = property[0]
    var productId = lineItem.product_id
    var filteredNames = $(dropdownOption).filter(function (idx) {
      return `${dropdownOption[idx].id}` === variantId
    });
    var objects = {}
    $(filteredNames).each(function () {
      objects = this
    })
 
    var divId = key+variantId+lineItem.id+index
    var lineVariantId = productId + lineItem.id + variantId
    var stoneOption = `<img src="` + objects.imageUrl + `" alt="` + objects.title + `" class="stone-thumb"/><span class="stone-title">` + objects.title + `</span>`;
    var stoneVal = objects.title + ` (+$` + objects.price + `)`;
    var indexs = parseInt(index)
    var htmlDiv = '';
    var countkey = property[0]
    var stonekey = countkey.replace(/_/g, ' ')
    var keystonecount = stonekey.substring(7);

    htmlDiv += `<div class="ProductForm__Option">`;
    htmlDiv += `<button id="btn-popover-` + lineVariantId + `-product-template-stone-options` + index + `" type="button" class="ProductForm__Item custom_stone_dropdown" aria-expanded="false" aria-controls="popover-` + lineVariantId + index + `-product-template-stone-options` + index + `">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="stone-lable">` + keystonecount + ` </span><span class="ProductForm__SelectedValue` + lineVariantId + index + ` stone-selected-value">` + stoneOption + `</span></span>`
    htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_` + index + `]" class="custom_stone_` + lineVariantId + index + `_selectedvalue custom_variantId" value='` + variantId + `' data-required='true'>`;
    htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_Title_` + index + `]" class="custom_stone_title` + lineVariantId + index + `_selectedvalue" value='` + stoneVal + `'>`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button></div>`;
    var htmlDivPop = '';
    htmlDivPop += `<div id="popover-` + lineVariantId + `-product-template-stone-options` + index + `" class="OptionSelector custom_stone_popover cart_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDivPop += `<header class="Popover__Header">`;
    htmlDivPop += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDivPop += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDivPop += `</svg></button>`;
    htmlDivPop += `<span class="Popover__Title Heading u-h4">Custom Stone</span>`;
    htmlDivPop += `</header>`
    htmlDivPop += `<div class="Popover__Content">`;
    htmlDivPop += `<div class="Popover__ValueList" data-scrollable="">`;

    for (var j = 0; j < dropdownOption.length; j++) {
      var variant = dropdownOption[j];
      htmlDivPop += `<button type="button" class="custom_stone_variant_option Popover__Value  Heading Link Link--primary u-h6" quantity="` + lineItem.quantity + `" oldId="` + lineVariantId + `" data-line-index="` + index + `" data-line-key="` + key + `" data-line-id="` + lineItem.key + `" action="cart" image-url="` + variant.imageUrl + `" parent-index="` + index + `" index="` + j + `" data-price="` + variant.price + `" data-title="` + variant.title + `" data-value="` + variant.id + `" data-option-position="` + index + `">`;
      htmlDivPop += `<img src="` + variant.imageUrl + `" alt="` + variant.title + `" class="stone-thumb" />`;
      htmlDivPop += `<span class="stone-title">` + variant.title + `</span>`;
      htmlDivPop += `</button>`;
    }
    htmlDivPop += `</div>`;
    htmlDivPop += `</div>`;
    htmlDivPop += `</div>`;

    jQuery('#shopify-section-footer').after(htmlDivPop)
    jQuery('#' + divId).html("")
    jQuery('#' + divId).append(htmlDiv)
  } else {
    return ''
  }
  /* Enabling Add to cart button */
  enableAddToCartButton()
  stopScreenFreeze()
}

/*** Custom stone count function ***/
function getOptionsVals(v, optionVal) {
  var vals = 0;
  var productOptions = '';
  var getProductAction = jQuery("#pageActionProduct").text();
  if (getProductAction && getProductAction !== '') {
    productOptions = JSON.parse(jQuery("#pageActionProduct").text())
  }
  if (productOptions !== '' && (typeof productOptions === 'object')) {
    for (var k = 0; k < productOptions.length; k++) {
      if (productOptions && productOptions[k] &&
        (productOptions[k] === optionVal || productOptions[k] === optionVal ||
          productOptions[k].toLowerCase() === optionVal.toLowerCase() ||
          productOptions[k].toLowerCase() === optionVal.toLowerCase())) {
        switch (k) {
          case 0:
            vals = v.option1
            break
          case 1:
            vals = v.option2
            break
          case 2:
            vals = v.option3
            break
        }
      }
    }
    return vals;
  }
}

/* This function return the object for default values for selection when the product Id is given */
function getValuesByProductId(productId) {
  return defaultSelections.hasOwnProperty(productId) ? defaultSelections[productId] : null;
}

/* This function updates the object for default values for selection when the product Id is given with updating keys */
function updateValuesByProductId(productId, updatedValues) {
  if (defaultSelections.hasOwnProperty(parseInt(productId))) {
    defaultSelections[productId] = Object.assign({}, defaultSelections[productId], updatedValues);
    return true;
  } else {
    return false;
  }
}

function customStoneCount(v, productId, customStoneCount) {
  var dropdownOption = customStoneDropDownOptions;
  if (customStoneCount === "custom-stone-count-2")  dropdownOption = customStoneDropDownOptionsTwo
  if (customStoneCount === "custom-stone-count-band")  dropdownOption = customStoneDropDownOptionBand
  if (dropdownOption.length) {
    jQuery('#custom-stones').html("")
    var productValues = getValuesByProductId(productId);
    var vals = getOptionsVals(v, 'Birthstone Count') || getOptionsVals(v, 'Stone Count');
    var checkEngravingStyleOptions = currentProductJson.tags.filter(s => s.includes('11/12/24 Personalized Gemstone Eternity Bands'));
    var dropdownLabel = 'Stone';
    checkEngravingStyleOptions && checkEngravingStyleOptions.length ?  dropdownLabel = 'Birthstone' : dropdownLabel = 'Stone';
    
    var htmlDiv = ''
    var appendArray = []
    for (var i = 1; i <= vals; i++) {
      htmlDiv += `<div class="ProductForm__Option">`;
      htmlDiv += `<button id="btn-popover-` + productId + v.id + `-product-template-stone-options` + i + `" type="button" class="ProductForm__Item custom_stone_dropdown" aria-expanded="false" aria-controls="popover-` + productId + v.id + `-product-template-stone-options` + i + `">`;
      htmlDiv += `<span class="ProductForm__OptionName"><span class="stone-lable">`+ dropdownLabel +` ` + i + `: </span><span class="ProductForm__SelectedValue` + productId + v.id + i + ` stone-selected-value">`
      if (productValues['stoneTitle_' + i + ''] !== 'Select' && productValues['stoneTitle_' + i + ''] !== 'Select') {
        htmlDiv += `<img src="` + productValues['imgUrl_' + i + ''] + `" alt="` + productValues['stoneTitle_' + i + ''] + `" class="stone-thumb">`
      }
      htmlDiv += `<span class="stone-title">` + productValues['stoneTitle_' + i + ''] + `</span>`
      htmlDiv += `</span></span>`
      if (productValues['stoneTitle_' + i + ''] !== 'Select' && productValues['stoneTitle_' + i + ''] !== 'Select') {
        htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_Title_` + i + `]" class="custom_stone_title` + productId + v.id + i + `_selectedvalue" value='` + productValues['stoneTitle_' + i + ''] + `' data-required='true'>`;
      } else {
        htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_Title_` + i + `]" class="custom_stone_title` + productId + v.id + i + `_selectedvalue" value='' data-required='true'>`;
      }
      htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_` + i + `]" class="custom_stone_` + productId + v.id + i + `_selectedvalue custom_variantId" value='` + productValues['stoneId_' + i + ''] + `' data-required='true'>`;
      htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
      htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
      htmlDiv += `</svg>`;
      htmlDiv += `</button><div class="errormsg stone-error"></div>`; /* RC-367 Error message updates*/
      htmlDiv += `<div id="popover-` + productId + v.id + `-product-template-stone-options` + i + `" class="OptionSelector custom_stone_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
      htmlDiv += `<header class="Popover__Header">`;
      htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
      htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
      htmlDiv += `</svg></button>`;
      htmlDiv += `<span class="Popover__Title Heading u-h4">Custom Stone</span>`;
      htmlDiv += `</header>`
      htmlDiv += `<div class="Popover__Content">`;
      htmlDiv += `<div class="Popover__ValueList" data-scrollable="">`;
      for (var j = 0; j < dropdownOption.length; j++) {
        var variant = dropdownOption[j];
        htmlDiv += `<button type="button" class="custom_stone_variant_option Popover__Value  Heading Link Link--primary u-h6" data-product_id="` + productId + `" oldId="` + productId + v.id + `" image-url="` + variant.imageUrl + `" parent-index="` + i + `" index="` + j + `" data-price="` + variant.price + `" data-title="` + variant.title + `" data-value="` + variant.id + `" data-option-position="` + i + `">`;
        htmlDiv += `<img src="` + variant.imageUrl + `" alt="` + variant.title + `" class="stone-thumb"/>`;
        htmlDiv += `<span class="stone-title">` + variant.title + `</span>`;
        htmlDiv += `</button>`;
      }
      htmlDiv += `</div>`;
      htmlDiv += `</div>`;
      htmlDiv += `</div></div>`;

      if (appendArray.indexOf(i) === -1) {
        appendArray.push(i)
      }
    }
    jQuery('#custom-stones').append(htmlDiv);
    /* Inserting #custom-stones after the Birthstone Count element */
    if (jQuery('.Birthstone.Count.ProductForm__Option.ProductForm__Option--labelled').length) {
      jQuery('#custom-stones').insertAfter(jQuery('.Birthstone.Count.ProductForm__Option.ProductForm__Option--labelled').first());
    }

    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionStone()
    stopScreenFreeze()
  }
}

/*** Fetch color dropdown variants Array function ***/
var colordropOptions = [];
function colorDropdownArray() {
  getProductByHandle(`color-dropdown`)
    .then(function (colordropdownGhostProduct) {
      var optionsArr = []
      for (var i = 0; i < colordropdownGhostProduct.product.variants.length; i++) {
        var filteredNames = $(colordropdownGhostProduct.product.images).filter(function (idx) {
          return colordropdownGhostProduct.product.images[idx].id === colordropdownGhostProduct.product.variants[i].image_id
        });
        $(filteredNames).each(function () {
          colordropdownGhostProduct.product.variants[i].imageUrl = this.src;
        })
      }
      return colordropdownGhostProduct.product.variants;
    }).then(function (options) {
      colordropOptions = options
      return colordropOptions
    })
}

function closedPopOver(action_control) {
  if (action_control.indexOf('womensize') === -1 ||
    action_control.indexOf('mensize') === -1) {
    jQuery(".womensize_dropdown_popover,.mensize_dropdown_popover").attr("aria-hidden", true)
  }
}

function setClickActionStone() {
  jQuery(".custom_stone_dropdown").click(function (e) {
    e.stopImmediatePropagation()
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })

    /* Handling screen freeze using CSS Class*/
    $("body").toggleClass("is-rc-open is-rc-close", $(this).attr("aria-expanded") != "true");

    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true

      if (windowWidth > 1024) {
        tops = pos.top - 100 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        setTimeout(function () {
          $(".PageOverlay").addClass('is-visible')
          tops = windowWidth - 140
        }, 100);
      }

      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
    $('body').css("overflow", "hidden");
  })
  popoverClosed()
}

/* Applying condition on clicking on Pageoverlay classs */
jQuery(".PageOverlay").click(function () {
  var divId = jQuery(this).attr('id')
  var colrpop = jQuery(".color_dropdown_popover").attr('aria-hidden');
  var fontsrpop = jQuery(".fontfamily_dropdown_popover").attr('aria-hidden');
  var mensrpop = jQuery(".mensize_dropdown_popover").attr('aria-hidden');
  var womensrpop = jQuery(".womens_dropdown_popover").attr('aria-hidden');
  var customsizepop = jQuery(".custom_size_dropdown_popover").attr('aria-hidden');
  var pearspop = jQuery(".pearstone_dropdown_popover").attr('aria-hidden');
  var emeraldrpop = jQuery(".emeraldstone_dropdown_popover").attr('aria-hidden');
  var caratweightpopup = jQuery(".carat_weight_dropdown_popover").attr('aria-hidden');
  var zodiaconepop = jQuery(".zodiac_one_dropdown_popover").attr('aria-hidden');
  var zodiactwopop = jQuery(".zodiac_two_dropdown_popover").attr('aria-hidden');
  var engravablepop = jQuery(".engravable_dropdown_popover").attr('aria-hidden');

  if (colrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".color_dropdown_popover").attr('aria-hidden', true)
  } else if (mensrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".mensize_dropdown_popover").attr('aria-hidden', true)
  } else if (fontsrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".fontfamily_dropdown_popover").attr('aria-hidden', true)
  } else if (womensrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".womens_dropdown_popover").attr('aria-hidden', true)
  } else if (pearspop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".pearstone_dropdown_popover").attr('aria-hidden', true)
  } else if (emeraldrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".emeraldstone_dropdown_popover").attr('aria-hidden', true)
  } else if (caratweightpopup === "false") {
    $(this).removeClass("is-visible")
    jQuery(".carat_weight_dropdown_popover").attr('aria-hidden', true)
  } else if (zodiaconepop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".zodiac_one_dropdown_popover").attr('aria-hidden', true)
  } else if (zodiactwopop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".zodiac_two_dropdown_popover").attr('aria-hidden', true)
  } else if (engravablepop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".engravable_dropdown_popover").attr('aria-hidden', true)
  } else if (customsizepop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".custom_size_dropdown_popover").attr('aria-hidden', true)
  }

  jQuery(".custom_stone_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== divId) {
      jQuery(".custom_stone_popover").attr('aria-hidden', true)
      $('.PageOverlay').removeClass("is-visible")
    }
  })
  jQuery(".fontfamily_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== divId) {
      jQuery(".fontfamily_dropdown_popover").attr('aria-hidden', true)
      $('.PageOverlay').removeClass("is-visible")
    }
  })
  /* Closing Searchbar on click of page overlay */
  if($('#Search').attr('aria-hidden') === 'false') {
    $('.Search__Close').trigger("click")
  }
})

$('.Cart-ProductForm__Item').click(function (e) {
  var id = $(this).attr('id');
  var pos = $("#" + id).offset();
  var windowWidth = $(document).width();
  var scrollHeight = $(window).scrollTop();
  var tops = 0;
  if (pos && id) {
    var right = (windowWidth - pos.left + 20);
    var left = (windowWidth - pos.right + 20);
    var rightLeft = true
    if (windowWidth > 1024) {
      tops = pos.top - 100 - scrollHeight
    } else if (windowWidth === 1024) {
      rightLeft = false
      tops = pos.top - 160 - scrollHeight
    } else if (windowWidth > 768 && windowWidth < 1024) {
      tops = pos.top - 160 - scrollHeight
    } else {
      $(".PageOverlay").addClass('is-visible')
      tops = windowWidth - 160
    }
  }
  var ids = $(this).attr('aria-controls');
  $('.OptionSelector').each(function () {
    var idss = $(this).attr('id');
    if (idss == ids) {
      if (windowWidth > 768) {
        $('.Cart-ProductForm__Option__Parent').find(`#${idss}`).attr('aria-hidden', 'false');
        $('.Cart-ProductForm__Option__Parent').find(`#${idss}`).css({ top: tops, right: right })
        $("html").addClass("no-scroll")
      } else {
        $('.Cart-ProductForm__Option__Parent').find(`#${idss}`).attr('aria-hidden', 'false');
      }
    } else {
      $('.Cart-ProductForm__Option__Parent').find(`#${idss}`).attr('aria-hidden', 'true');
    }
  });
});

$('body').click(function (e) {
  var noScroll = false
  var pageActionPro = jQuery("#pageActionProduct").text();
  var pageActionCart = jQuery("#pageActionCart").text();
  jQuery(".OptionSelector.Popover").each(function () {
    if ($(this).attr('aria-hidden') === "false") noScroll = true
  })
  if (noScroll) {
    jQuery("html").addClass("no-scroll")
  } else {
    if ($("#Search").attr("aria-hidden") === true) jQuery("html").removeClass("no-scroll");
  }
  if (noScroll && pageActionCart && pageActionCart === 'Cart' && $(e.target).closest(".CartItem__Property").length === 0) {
    jQuery("html").removeClass("no-scroll")
  }
  if (noScroll && pageActionPro && pageActionPro !== '' && $(e.target).closest(".ProductForm__Variants ").length === 0) {
    jQuery("html").removeClass("no-scroll")
  }
  $('body').removeClass('is-rc-open')
  $('html').removeClass("no-scroll")
});

function popoverClosed() {
  jQuery(".Popover__Close.Icon-Wrapper--clickable").click(function () {
    $(".PageOverlay").removeClass('is-visible')
    jQuery(this).parent().parent().attr('aria-hidden', true)
  })
  /* custom stone dropdown option selection function */
  jQuery(".custom_stone_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var price = jQuery(this).attr('data-price')
    var index = jQuery(this).attr('index')
    var parentIndex = jQuery(this).attr('parent-index')
    var imageUrl = jQuery(this).attr('image-url')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var product_id = jQuery(this).attr("data-product_id")
    var lineidkeyTitle = `Custom_Stone_Title_` + lineidIndex
    var mainQuantity = jQuery(this).attr("quantity")
    var updatedValues = {};
    updatedValues['stoneTitle_' + parentIndex] = title;
    updatedValues['stoneId_' + parentIndex] = variantId;
    updatedValues['imgUrl_' + parentIndex] = imageUrl;

    /* Updating the default vaules in the Json in Global file */
    updateValuesByProductId(product_id, updatedValues);

    if (!mainQuantity) mainQuantity = 1
    var divids = oldId + '' + parentIndex;
    var className = 'stone-thumb'
    var saveVariant = jQuery(".custom_stone_" + divids + "_selectedvalue").attr('value')
    var stoneOption = `<img src="` + imageUrl + `" alt="` + title + `" class="` + className + `"/><span class="stone-title"> ` + title + `</span>`;
    var stoneVal = title + ` (+$` + price + `)`;
    if (price === '0.00') stoneVal = title;
    jQuery(".ProductForm__SelectedValue" + divids).html(stoneOption)
    jQuery(".custom_stone_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".custom_stone_title" + divids + "_selectedvalue").attr('value', stoneVal)
    jQuery(this).closest(".custom_stone_popover").attr('aria-hidden', true)
    jQuery(".custom_stone_dropdown").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')

    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      updateCartvalues(variantId, lineid, lineidIndex, lineidkey, lineidkeyTitle, stoneVal)
    }
  })

  /* color drop down option selection function */
  jQuery(".color_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    defaultMetalVarId = variantId;
    var title = jQuery(this).attr('data-title')
    defaultMetalName = title;
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var saveVariant = jQuery(".color_dropdown_" + variantId + "_selectedvalue").attr('value')
    var dropdownOption = `<span class="dropdown-title"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValue" + divids).html(dropdownOption)
    jQuery(".color_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".color_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".color_dropdown_popover").attr('aria-hidden', true)
    jQuery(".color_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')

    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey)
      }, 1000)
    }
  })

  /* Mens size drop down option selection function */
  jQuery(".mensize_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var saveVariant = jQuery(".mensize_dropdown_" + variantId + "_selectedvalue").attr('value')
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_selected_size"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValueMens" + divids).html(dropdownOption)
    jQuery(".mensize_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".mensize_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".mensize_dropdown_popover").attr('aria-hidden', true)
    jQuery(".mensize_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')

    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey)
      }, 1000)
    }
  })

  /* Font family drop down option selection function */
  jQuery(".fontfamily_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_font_family"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValueFonts" + divids).html(dropdownOption)
    jQuery(".fontfamily_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".fontfamily_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".fontfamily_dropdown_popover").attr('aria-hidden', true)
    jQuery(".fontfamily_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')
    /* Change Font family dynamically */
    var getCount = $('#customization').val().length;
    var getValue = $('#customization').val();
    var getFontFamily = $('.get_variant_font_family').text();
    $('#customization_count').val(getCount);
    $('#previewText').text(getValue);
    $('#previewText').css('font-family', getFontFamily.replaceAll(/\s/g, ''))
  })

  /* Womens size drop down option selection function */
  jQuery(".womensize_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var saveVariant = jQuery(".womensize_dropdown_" + variantId + "_selectedvalue").attr('value')
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_selected_size"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValueWomens" + divids).html(dropdownOption)
    jQuery(".womensize_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".womensize_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".womensize_dropdown_popover").attr('aria-hidden', true)
    jQuery(".womensize_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')

    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey)
      }, 1000)
    }
  })

  /* Custom Diamond Coverage drop down option selection function */
  jQuery(".diamond_coverage_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var saveVariant = jQuery(".womensize_dropdown_" + variantId + "_selectedvalue").attr('value')
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_selected_size"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValue_Diamond_Coverage" + divids).html(dropdownOption)
    jQuery(".diamond_coverage_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".diamond_coverage_dropdown_popover").attr('aria-hidden', true)
    jQuery(".diamond_coverage_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')
  })

  /* Pear stone drop down option selection function */
  jQuery(".pearstone_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var imageUrl = jQuery(this).attr('image-url')
    pearStoneImg = imageUrl
    var price = jQuery(this).attr('data-price')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var lineidkeyTitle = `Pear_Stone_` + lineidIndex
    var divids = oldId;
    var className = 'stone-thumb-selected';
    var saveVariant = jQuery(".pearstone_dropdown_" + variantId + "_selectedvalue").attr('value');
    var stoneVal = title + ` (+$` + price + `)`;
    var dropdownOption = `<img src="` + imageUrl + `" alt="` + title + `" class="` + className + `"/><span class="stone-title"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValuePearstone" + divids).html(dropdownOption)
    jQuery(".pearstone_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    pearStoneValue = jQuery(".pearstone_dropdown_" + divids + "_selectedvalue").attr('value')
    jQuery(".pearstone_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    pearStoneTitle = jQuery(".pearstone_dropdown_title" + divids + "_selectedvalue").attr('value')
    jQuery(this).closest(".pearstone_dropdown_popover").attr('aria-hidden', true)
    jQuery(".pearstone_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $("body").removeClass("noscroll")
    $(".PageOverlay").removeClass('is-visible')

    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey, lineidkeyTitle, stoneVal)
      }, 1000)
    }
    previewColorCombinationButton("_toi_moi_image")
  })

  /* Emerald stone drop down option selection function */
  jQuery(".emeraldstone_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var imageUrl = jQuery(this).attr('image-url')
    emeraldStoneImg = imageUrl;
    var price = jQuery(this).attr('data-price')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var lineidkeyTitle = `Emerald_Stone_` + lineidIndex
    var divids = oldId;
    var className = 'stone-thumb-selected';
    var saveVariant = jQuery(".emeraldstone_dropdown_" + variantId + "_selectedvalue").attr('value');
    var stoneVal = title + ` (+$` + price + `)`;
    var dropdownOption = `<img src="` + imageUrl + `" alt="` + title + `" class="` + className + `"/><span class="stone-title"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    jQuery(".ProductForm__SelectedValueEmeraldstone" + divids).html(dropdownOption)
    jQuery(".emeraldstone_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    emeraldStoneValue = jQuery(".emeraldstone_dropdown_" + divids + "_selectedvalue").attr('value');
    jQuery(".emeraldstone_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    emeraldStoneTitle = jQuery(".emeraldstone_dropdown_title" + divids + "_selectedvalue").attr('value');
    jQuery(this).closest(".emeraldstone_dropdown_popover").attr('aria-hidden', true)
    jQuery(".emeraldstone_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    $("body").removeClass("noscroll")

    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey, lineidkeyTitle, stoneVal)
      }, 1000)
    }
    previewColorCombinationButton("_toi_moi_image");
  })

  /* Zodiac One drop down option selection function */
  jQuery(".zodiac_one_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    var divids = oldId;
    var dropdownOption = `<span class="stone-title"> ` + title + `</span>`;
    var dropdownVal = title;

    jQuery(".ProductForm__SelectedValueZodiacOne" + divids).html(dropdownOption)
    jQuery(".zodiac_one_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".zodiac_one_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    zodiacOneTitle = jQuery(".zodiac_one_dropdown_title" + divids + "_selectedvalue").attr('value');
    jQuery(this).closest(".zodiac_one_dropdown_popover").attr('aria-hidden', true)
    jQuery(".zodiac_one_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    previewColorCombinationButton("_zodiac_image")
  })

  /* Zodiac two drop down option selection function */
  jQuery(".zodiac_two_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')

    var divids = oldId;
    var dropdownOption = `<span class="stone-title"> ` + title + `</span>`;
    var dropdownVal = title;

    jQuery(".ProductForm__SelectedValueZodiacTwo" + divids).html(dropdownOption)
    jQuery(".zodiac_two_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".zodiac_two_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    zodiacTwoTitle = jQuery(".zodiac_two_dropdown_title" + divids + "_selectedvalue").attr('value');
    jQuery(this).closest(".zodiac_two_dropdown_popover").attr('aria-hidden', true)
    jQuery(".zodiac_two_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    previewColorCombinationButton("_zodiac_image")
  })

  /* Engravable drop down option selection function */
  $(".engravable_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = $(this).attr('data-value')
    var title = $(this).attr('data-title')
    var fontFamily = $(this).attr('data-title')
    var textStyle = "none";
    var firstTextValue = $('#input-text-engraving-styles').val();
    var secondTextValue = $('#engravable_placement_dropdown_input_box').val();
    var optionalTextValue = $('#input-text-engraving-styles-optional').val();
    var optionalTextValueThree = $('#input-text-engraving-styles-optional-three').val();
    
    if (fontFamily === "Bernhard Tango") {
      fontFamily = "BernhardTangoBT"
    } else if (fontFamily === "Celine") {
      fontFamily = "BV Celine";
      textStyle = "uppercase";
    } else if (fontFamily === "Constane") {
      fontFamily = "Constane"
    } else {
      fontFamily = fontFamily.replace(/\s/g, "");
    }

    var oldId = $(this).attr("oldId")
    $("body").addClass('is-rc-close')
    $("html").removeClass('no-scroll')
    $("#fontFamilyPreview").css("font-family", fontFamily).css("text-transform", textStyle).text(firstTextValue);
    $("#fontFamilyPreviewTwo").css("font-family", fontFamily).css("text-transform", textStyle).text(secondTextValue);
    $("#fontFamilyPreviewOptional").css("font-family", fontFamily).css("text-transform", textStyle).text(optionalTextValue);
    $("#fontFamilyPreviewOptionalThree").css("font-family", fontFamily).css("text-transform", textStyle).text(optionalTextValueThree);
    const elements = $('#input-text-engraving-styles, #engravable_placement_dropdown_input_box, #input-text-engraving-styles-optional-three');
    textStyle === 'none' ? elements.removeClass('capitalize-input') : elements.addClass('capitalize-input');
    
    var divids = oldId;
    var dropdownOption = `<span class="engravable-title" id="selected-engravable-font"> ` + title + `</span>`;
    var dropdownVal = title;

    $(".ProductForm__SelectedValueEngravable" + divids).html(dropdownOption)
    $(".engravable_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    $(".engravable_option_value" + divids + "_selectedvalue").attr('value', dropdownVal)
    $(this).closest(".engravable_dropdown_popover").attr('aria-hidden', true)
    $(".engravable_drop_down").attr('aria-expanded', false)
    $("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    previewColorCombinationButton("_engraving_image")
    changeInputNumbers()
  })

  /* Font drop down option selection function */
  jQuery(".font_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var fontFamily = jQuery(this).attr('data-title')
    var textStyle = "none";
    
    if (fontFamily === "Bernhard Tango") {
      fontFamily = "BernhardTangoBT"
    } else if (fontFamily === "Celine") {
      fontFamily = "BV Celine";
      textStyle = "uppercase";
    } else if (fontFamily === "Constane") {
      fontFamily = "Constane"
    } else if (fontFamily === "Seagram") {
      fontFamily = "Seagramtfb";
    } else {
      fontFamily = fontFamily.replace(/\s/g, "");
    }

    var oldId = jQuery(this).attr("oldId")
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    
    var divids = oldId;
    var dropdownOption = `<span class="font-title" id="selected-font"> ` + title + `</span>`;
    var dropdownVal = title;

    jQuery(".ProductForm__SelectedValueFont" + divids).html(dropdownOption)
    jQuery(".font_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".font_option_value" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(".fontPreviewCustomize").css("font-family",fontFamily).css("text-transform", textStyle);
    jQuery("#fontName").val(title)
    jQuery(this).closest(".font_dropdown_popover").attr('aria-hidden', true)
    jQuery(".font_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
  })

  /* Engravable Placement drop down option selection function */
  jQuery(".engravable_placement_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value');
    var title = jQuery(this).attr('data-title');
    var oldId = jQuery(this).attr("oldId");
    jQuery("body").addClass('is-rc-close');
    jQuery("html").removeClass('no-scroll');
    var divids = oldId;
    var dropdownOption = `<span class="engravable-placement-title" id="selected-engravable-placement">` + title + `</span>`;
    var dropdownVal = title;
    var trimmedTitle = dropdownVal.trim().toLowerCase().replace(/\s/g, "");
    if (trimmedTitle === "center-2lines" || trimmedTitle === "bottomright-2lines" || trimmedTitle === "center") {
      var grabFontFamily = $("#selected-engravable-font").text().trim();
      var textStyle = "none";
      if (grabFontFamily === "Celine") {
        grabFontFamily = "BV Celine";
        textStyle = "uppercase";
      } else if (grabFontFamily === "Constane") {
        grabFontFamily = "Constane";
      } else if (grabFontFamily === "Bernhard Tango") {
        grabFontFamily = "BernhardTangoBT";
      } else {
        grabFontFamily = grabFontFamily.replace(/\s+/g, "");
      }
      $(".Customization-DropDown-Placement").removeClass("hide");
      $("#engravingTextTwo").remove();
      $("#fontFamilyPreviewTwo").remove();
      $('form[action="/cart/add"]').append(`<input type="hidden" id="engravingTextTwo" class="engravable_customization_two_value" data-required="true" name="properties[Engraving_Text_2]" value=''/>`)
      document.querySelector('.engraving-wrapper.Customization-DropDown-Placement').insertAdjacentHTML('afterend', '<p id="fontFamilyPreviewTwo" style="font-family:'+ grabFontFamily +';text-transform: '+ textStyle +'" class="fontPreviewTwo"></p>');
    } else {
      $("#engravingTextTwo").remove();
      $("#fontFamilyPreviewTwo").remove();
      $(".Customization-DropDown-Placement").addClass("hide");
      $(".engravable-text-two-error").addClass("hide");
    }
    
    customeInputBoxMaxLenghtSet(trimmedTitle);
    
    $('form[action="/cart/add"]').find(`input[name="properties[_engravingplacement]"]`).attr("value", title);
    jQuery(".ProductForm__SelectedValueEngravablePlacement" + divids).html(dropdownOption);
    jQuery(".engravable_placement_dropdown_" + divids + "_selectedvalue").attr('value', variantId);
    jQuery(".engravable_placement_option_value" + divids + "_selectedvalue").attr('value', dropdownVal);
    jQuery(this).closest(".engravable_placement_dropdown_popover").attr('aria-hidden', true);
    jQuery(".engravable_placement_drop_down").attr('aria-expanded', false);
    jQuery("body").addClass('is-rc-close');
    $(".PageOverlay").removeClass('is-visible');
    previewColorCombinationButton("_engraving_image")
  });
  
  function customeInputBoxMaxLenghtSet(trimmedTitle) {
    var engravablePlacementInputBox = $('.engravable_placement_dropdown_input_box');
    var inputTextEngravingStyles = $('#input-text-engraving-styles');
    var checkEngravingStyleOptions = currentProductJson.tags.filter(s => s.includes('engraving-style-options'));

    engravablePlacementInputBox.removeAttr('maxlength').val('')
    inputTextEngravingStyles.removeAttr('maxlength').val('')
    $('#fontFamilyPreview').text("")
    $('#fontFamilyPreviewTwo').text("")
    $('#engravingText').val("")
    $('#engravingTextTwo').val("")

    var maxlengthValueOne, maxlengthValueTwo;
    
    switch (trimmedTitle) {
      case 'rightvertical':
        maxlengthValueOne = 13;
        $("#engravingText").attr('data-required', true);
        break;
      case 'center-1line':
        maxlengthValueOne = 10;
        $("#engravingText").attr('data-required', true);
        break;
      case 'center-2lines':
        maxlengthValueOne = 7;
        maxlengthValueTwo = 10;
        $("#engravingText").attr('data-required', true);
        break;
      case 'center':
        maxlengthValueOne = 12;
        maxlengthValueTwo = 12;
        $("#engravingTextTwo").removeAttr('data-required')
        break;  
      case 'bottomright-1line':
        maxlengthValueOne = 4;
        $("#engravingText").attr('data-required', true);
        break;  
      case 'bottomright-2lines':
        maxlengthValueOne = 2;
        maxlengthValueTwo = 4;
        $("#engravingText").attr('data-required', true);
        break;
      default:
        maxlengthValueOne = 10;
        maxlengthValueTwo = 10;
        break;
    }
    
    if(trimmedTitle === 'rightvertical' && checkEngravingStyleOptions.length) maxlengthValueOne = 12
    
    /* Input Character First */
    $("#charCountEnraging").text("0/" + maxlengthValueOne);
    inputTextEngravingStyles.attr('maxlength', maxlengthValueOne).off('input').on('input', function() {
      var currentLength = $(this).val().length;
      $('#charCountEnraging').text(currentLength + '/' + maxlengthValueOne);
    });
    
    /* Input Character Second */
    $("#character_count_display").text("0/" + maxlengthValueTwo);
    engravablePlacementInputBox.attr('maxlength', maxlengthValueTwo).off('input').on('input', function() {
      var currentLength = $(this).val().length;
      $('#character_count_display').text(currentLength + '/' + maxlengthValueTwo);
    });
  }
  
  async function filterTagsContainingBespokeSize(tags) {
    var bespokeSizeTags = tags.filter(tag => tag.includes('bespoke-size-'));
    var bespokeSizes = bespokeSizeTags.map(tag => parseFloat(tag.replace('bespoke-size-', '')));
    return bespokeSizes;
  }
  
  /* Custom Size drop down option selection function */ 
  jQuery(".custom_size_dropdown_variant_option").click(async function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var customSizeBespokeFlashProductsSoldOut = currentProductJson ? currentProductJson.tags.filter(s => s.includes('is-bespoke-sold-out')) : [];
    var isOMSLeadTimeMadeToOrder = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-made-to-order')) : [];
    var isOMSLeadTimeInStock = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-in-stock')) : [];
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    
    var bespokeSizeTags = await filterTagsContainingBespokeSize(currentProductJson.tags);
    var divids = oldId;
    var dropdownOption = `<span class="custom-size"> ` + title + `</span>`;
    var dropdownVal = title;

    jQuery(".ProductForm__SelectedValueCustomSize" + divids).html(dropdownOption)
    jQuery(".custom_size_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".custom_size_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".custom_size_dropdown_popover").attr('aria-hidden', true)
    jQuery(".custom_size_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    // $(".ProductForm__AddToCart").attr("disabled", "disabled")
    
    var ifLeadTimeFieldIsPresent = jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).length
    if(customSizeBespokeFlashProductsSoldOut && customSizeBespokeFlashProductsSoldOut.length !== 0){
      $(".stock-level-message").html("Sold out")
    } else {
      if((bespokeSizeTags.includes(parseFloat(title)) && isOMSLeadTimeMadeToOrder.length === 0) || (bespokeSizeTags.includes(parseFloat(title)) && isOMSLeadTimeInStock.length)){
        $(".stock-level-message").html("Only 1 left in stock!")
        $('.inv-label--in-stock').removeClass('hide')
        $('.inv-label--out-stock').addClass('hide')
        if (ifLeadTimeFieldIsPresent > 0) {
          jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", 'Only 1 left in stock!')
        } else {
          jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value="Only 1 left in stock!" />`)
        }
      } else {
        if((currentProductJson.type === "Lab Grown Engagement Rings" || currentProductJson.type === "Natural Engagement Ring") && isOMSLeadTimeMadeToOrder.length === 0 && isOMSLeadTimeInStock.length === 0){
          $(".stock-level-message").html("Estimated production time is 2 weeks.")
          $('.inv-label--out-stock').removeClass('hide')
          $('.inv-label--in-stock').addClass('hide')
          if (ifLeadTimeFieldIsPresent > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", 'Estimated production time is 2 weeks.')
          } else {
            jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value="Estimated production time is 2 weeks." />`)
          }
        } else if(isOMSLeadTimeInStock.length) {
          if(grabEngagementRingsLeadTime.trim() === "") {
            grabEngagementRingsLeadTime = "Estimated production time is 2 weeks.";
          }
          $(".stock-level-message").html(grabEngagementRingsLeadTime)
          $('.inv-label--out-stock').removeClass('hide')
          $('.inv-label--in-stock').addClass('hide')
          if (ifLeadTimeFieldIsPresent > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", grabEngagementRingsLeadTime)
          } else {
            jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value="${grabEngagementRingsLeadTime}" />`)
          }
        }
      }
    }
  })

  /* Combine Product Top 2 drop down option selection function */
  jQuery(".combine_product_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var variant = jQuery(this).attr('data-variant-id')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')

    var divids = oldId;
    var dropdownOption = `<span class="combine-product"> ` + title + `</span>`;
    var dropdownVal = title;

    jQuery(".combine_product_dropdown_variant_option").attr("var-id", variant)
    jQuery(".ProductForm__SelectedValueCombineProduct" + divids).html(dropdownOption)
    jQuery(".product_combination_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".product_combination_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(".product_combination_dropdown_variant_id_top_two" + divids + "_selectedvalue").attr('value', variant)
    jQuery(this).closest(".combine_product_dropdown_popover").attr('aria-hidden', true)
    jQuery(".combine_product_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    updateLeadtimeLinkProducts(undefined)
    getCombinationImages("multiwayCloudLinkEarrings")
  })

  /* Combine Product Bottom 1 drop down option selection function */
  jQuery(".combine_product_dropdown_variant_option_bottom_one").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var variant = jQuery(this).attr('data-variant-id')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')

    var divids = oldId;
    var dropdownOption = `<span class="combine-product-bottom-one"> ` + title + `</span>`;
    var dropdownVal = title;

    jQuery(".combine_product_dropdown_variant_option_bottom_one").attr("var-id", variant)
    jQuery(".ProductForm__SelectedValueCombineProductBottomOne" + divids).html(dropdownOption)
    jQuery(".product_combination_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".product_combination_dropdown_variant_id_bottom_one" + divids + "_selectedvalue").attr('value', variant)
    jQuery(".product_combination_bottom_one_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".combine_product_bottom_one_dropdown_popover").attr('aria-hidden', true)
    jQuery(".combine_product_bottom_one_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    updateLeadtimeLinkProducts(undefined)
    getCombinationImages("multiwayCloudLinkEarrings")
  })

  /* Combine Product Bottom 2 drop down option selection function */
  jQuery(".combine_product_dropdown_variant_option_bottom_two").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var variant = jQuery(this).attr('data-variant-id')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')

    var divids = oldId;
    var dropdownOption = `<span class="combine-product-bottom-two"> ` + title + `</span>`;
    var dropdownVal = title;

    jQuery(".combine_product_dropdown_variant_option_bottom_two").attr("var-id", variant)
    jQuery(".ProductForm__SelectedValueCombineProductBottomTwo" + divids).html(dropdownOption)
    jQuery(".product_combination_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".product_combination_bottom_two_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(".product_combination_bottom_two_dropdown_variant_id_bottom_two" + divids + "_selectedvalue").attr('value', variant)
    jQuery(this).closest(".combine_product_bottom_two_dropdown_popover").attr('aria-hidden', true)
    jQuery(".combine_product_bottom_two_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    updateLeadtimeLinkProducts(undefined)
    getCombinationImages("multiwayCloudLinkEarrings")
  })
}

function updateCartvalues(val, lineid, lineidIndex, lineidkey, lineidkeyTitle, titleVal) {
  var dataQuantity = 1
  $(".siteLoader").show()
  fetch("/cart.js?action=update_cart_values_get")
    .then(response => response.json())
    .then(cartData => {
      if (cartData && cartData.items && cartData.items.length > 0) {
        // Getting the clicked item in obj object
        var obj = null
        cartData.items.map(function (d, i) {
          if (d.key == lineid) {
            obj = d
          }
        })
        return { item: obj, cartData }
      }
    })
    .then(function (objs) {
      var allStoneGhostProductsForClickedVariant = []
      var validCustomStoneVariantId = []
      var inValidCustomStones = []
      if (objs.cartData.items.length > 0) {
        // Getting all the ghost product associated with the clicked variant
        var a = []
        objs.cartData.items.map(function (item, i) {
          if (item.properties && item.properties._stone_associated_variant_id == objs?.item?.variant_id) {
            a.push(item)
          }
        })
        allStoneGhostProductsForClickedVariant = a.filter(onlyUnique);
        // Getting all valid ghost products for the clicked variant      
        if (allStoneGhostProductsForClickedVariant.length > 0) {
          var b = []
          for (i = 1; i < 6; i++) {
            if (objs.item && objs.item.properties["_Custom_Stone_" + i]) {
              b.push(parseInt(objs.item.properties["_Custom_Stone_" + i]))
            }
          }
          validCustomStoneVariantId = b.filter(onlyUnique);
        }

        var c = []
        // Getting all non valid items from cart
        for (x = 0; x < allStoneGhostProductsForClickedVariant.length; x++) {
          var item = allStoneGhostProductsForClickedVariant[x]
          if (validCustomStoneVariantId.indexOf(item.properties["_associated_unique_key"]) === objs.item.properties["_associated_unique_key"] ) {
            c.push(item)
          }
        }

        // Getting changed stone item from cart and using break statement to not get duplicates
        for (x = 0; x < allStoneGhostProductsForClickedVariant.length; x++) {
          var item = allStoneGhostProductsForClickedVariant[x]
          if (objs.item && objs.item.properties && objs.item.properties[lineidkey] == item.variant_id) {
            c.push(item)
            break;
          }
        }
        // Getting unique items to remove
        inValidCustomStones = c.filter(onlyUnique);
      }

      if (lineid) {
        var itemsToRemove = { [lineid]: 0 }
        // Pushing invalid items in item to remove
        if (inValidCustomStones.length > 0) {
          inValidCustomStones.map(function (item, i) {
            itemsToRemove[item.key] = 0
          })
        }

        var item = objs.item
        var dataToSend = { id: item.id, quantity: item.quantity, properties: item.properties }
        dataToSend['properties'][`${lineidkey}`] = val
        var stoneTitleKey = lineidkey.replace("Stone_", "Stone_Title_")
        dataToSend['properties'][`${stoneTitleKey}`] = titleVal

        var newItem = [{
          id: parseInt(val),
          quantity: item.quantity,
          properties: {
            _stone_associated_variant_id: `${item.variant_id}`,
            _associated_unique_key: item.properties["_associated_unique_key"],
            _time_added: Date.now()
          }
        }]

        // Pushing clicked item with updated properties
        newItem.push(dataToSend)
        /**
        * Cart change API is not updating the line item properties 
        * so removing the clicked item and adding it again with new properties
        **/
        fetch('/cart/update.js?action=update', {
          body: JSON.stringify({ updates: itemsToRemove }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function (cart) {
          return fetch('/cart/add.js?action=add', {
            body: JSON.stringify({ items: newItem }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
        })
        .then(function (cart) {
          setTimeout(() => {
            $("input").prop('disabled', false);
            window.location.reload()
          }, 2000)
        })
        .catch(function (error) {
          $(".siteLoader").hide()
        })
      }
    })
}

/* Mobile Filter */
function mobileFilter() {
  $('.boost-pfs-check-box').click(function () {
    $(this).closest('.boost-pfs-filter-option').removeClass("boost-pfs-filter-option-collapsed");
    $(this).find('.boost-pfs-filter-option-content').removeClass("toggled");
  })
  $(".boost-pfs-filter-option").click(function () {
    if ($(this).hasClass('boost-pfs-filter-option-collapsed')) {
      $(this).addClass('boost-pfs-filter-option-collapsed')
      $(this).find(".boost-pfs-filter-option-content").addClass("toggled")
    } else {
      $(this).removeClass('boost-pfs-filter-option-collapsed')
      $(this).find(".boost-pfs-filter-option-content").removeClass("toggled")
    }
  })
}

/*** Reinitializing the flickity slider for mobile after search ***/
function reInitializeFlickityAfterSearch() {
  // On mobile images are not loading on first load. So executing this function after page load on collections with passed JSON object
  var nodeList = document.querySelectorAll('.js-flickity');
  for (var i = 0, t = nodeList.length; i < t; i++) {
    var flkty = Flickity.data(nodeList[i]);
    if (!flkty) {
      // Check if element had flickity options specified in data attribute.
      var flktyData = { fullscreen: true, pageDots: false, prevNextButtons: false, lazyLoad: 1 }
      new Flickity(nodeList[i], flktyData);
    }
  }
  if (localStorage.getItem("scrollToTop") !== 'true') window.scroll(0, 0);
  setTimeout(() => {
    localStorage.removeItem("scrollToTop");
  }, 3000)
  if ($(window).width() < 1008) {
    $(".CollectionToolbar__Item").click(function () {
      $('body').addClass('is-rc-open')
    });
    $('.Popover__Close, .Drawer__Close').click(function () {
      $('body').removeClass('is-rc-open')
    });
    $('.Popover__Value').click(function () {
      $('body').removeClass('is-rc-open')
    });
  }
}

/* Close popover on select dropdown */
$(".Popover__ValueList").click(function () {
  $("body").css("overflow", "visible");
});

/*  Globle Accordian function  */
var accordion = $('body').find('[data-behavior="accordion"]');
var expandedClass = 'is-expanded';

$.each(accordion, function () { // loop through all accordions on the page
  var accordionItems = $(this).find('[data-binding="expand-accordion-item"]');
  $.each(accordionItems, function () { // loop through all accordion items of each accordion
    var $this = $(this);
    var triggerBtn = $this.find('[data-binding="expand-accordion-trigger"]');
    var setHeight = function (nV) {
      var innerContent = nV.find('.accordion__content-inner')[0],
        maxHeight = $(innerContent).outerHeight(),
        content = nV.find('.accordion__content')[0];
      if (!content.style.height || content.style.height === '0px') {
        $(content).css('height', maxHeight);
      } else {
        $(content).css('height', '0px');
      }
    };
    var toggleClasses = function (event) {
      var clickedItem = event.currentTarget;
      var currentItem = $(clickedItem).closest('[data-binding="expand-accordion-item"]');
      var clickedContent = $(currentItem).find('.accordion__content')
      $(currentItem).toggleClass(expandedClass);
      setHeight(currentItem);

      if ($(currentItem).hasClass('is-expanded')) {
        $(clickedItem).attr('aria-expanded', 'true');
        $(clickedContent).attr('aria-hidden', 'false');
      } else {
        $(clickedItem).attr('aria-expanded', 'false');
        $(clickedContent).attr('aria-hidden', 'true');
      }
    }
    triggerBtn.on('click', event, function (e) {
      e.preventDefault();
      toggleClasses(event);
    });
    // open tabs if the spacebar or enter button is clicked whilst they are in focus
    $(triggerBtn).on('keydown', event, function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        toggleClasses(event);
      }
    });
  });
});

$(".CollectionToolbar__Item").on('click', function () {
  $('body').addClass("megamenu-open");
});
$(".Drawer__Close").on('click', function () {
  $('body').removeClass("megamenu-open");
});

$(window).scroll(function () {
  ($(this).scrollTop() > 1) ? $('.pdp-product-gallery').addClass('stickyClass') : $('.pdp-product-gallery').removeClass('stickyClass');
  if ($('#collection-sort-popover').attr('aria-hidden') == 'false') $('.CollectionToolbar__Item--sort').click();
});

/* Loading the List breaker (Bold Geometry Section) on Collection Grid */
function renderListBreakerComp(elem) {
  var listBreakerComponent = $(".collection-list-breaker");
  var collectionList = $('.ProductList .Grid__Cell');
  var Loader = $('.spinner-container');
  var currentPage = parseInt(elem.queryParams.page);
  if (collectionList.length) {
    collectionList.each(function (i) {
      /* Place list breaker component in between the grid only on page 1.*/
      if (currentPage === 1 && i === 11 && listBreakerComponent.length) {
        listBreakerComponent.clone(true).addClass("collection-list-breaker-cloned").insertAfter($(this)).fadeIn(400);
        listBreakerComponent.filter(':not(.collection-list-breaker-cloned)').hide();
      }
      $(".collection-list-breaker").toggleClass("hide", currentPage !== 1);
    });
    /* Show a loader so that there is no jump in the page and animate things smoothly. */
    if (Loader.length) {
      Loader.fadeOut(400, function () {
        $(this).hide();
      });
    }
  }
}

/* Loading the Static Image section on collection page */
function renderStaticImgShopTheLook(elem) {
  var staticImgShopTheLook = $(".static-image-shop-the-look");
  var collectionList = $('.ProductList .Grid__Cell');
  var currentPage = parseInt(elem.queryParams.page);
  if (collectionList.length) {
    /* Place Static Image Shop the look component in between the grid only on page 1. */
    if (currentPage === 1 && staticImgShopTheLook.length) {
      collectionList.slice(4, 8).wrapAll('<div class="static-img-grid"><div class="static-img-product-grid"></div></div>');
      staticImgShopTheLook.clone(true).addClass("static-img-shop-the-look-wrapper").appendTo(".static-img-grid");
      staticImgShopTheLook.filter(':not(.static-img-shop-the-look-wrapper)').hide();
    }
  }
}

/* Handling Screen Freeze Issue */
function stopScreenFreeze() {
  $('#custom-stones').children().find('button').click(function () {
    $(this).attr('aria-expanded', true)
  })
  $(".ProductForm__Option").find('button').click(function () {
    setTimeout(() => {
      if ($(this).attr("aria-expanded") == "true") {
        $("body").addClass("is-rc-open").removeClass("is-rc-close");
      } else {
        $("body").removeClass("is-rc-open").addClass("is-rc-close");
        $("html").removeClass("no-scroll")
      }
    }, 150)
  });
}

/* Handling Screen Freeze Issue for VOW */
if (currentProductTemplate && currentProductTemplate === 'vow.engagement.rings') {
  $(".product__select-list").find('button').click(function () {
    setTimeout(() => {
      if ($(this).attr("aria-expanded") == "true") {
        $("body").addClass("is-rc-open").removeClass("is-rc-close");
      } else {
        $("body").removeClass("is-rc-open").addClass("is-rc-close");
      }
    }, 100)
  });
}

/* On keyup it cancels the previous timer and create a new 1 second timer, Help to run function after user ends up typing... */
var timer = null;
var salePriceVariants = [];
$('.Search__Input').keyup(function () {
  clearTimeout(timer);
  timer = setTimeout(showSalePriceOnSearchBar, 1000)
});

/* Get ids from .showSalePriceOnSearch and show the salesPrice on UI */
function showSalePriceOnSearchBar() {
  $('.showSalePriceOnSearch').each(async function () {
    var productId = parseInt($(this).attr('data-product-id'));
    var variantId = parseInt($(this).attr('data-variant-id'));
    var variantDetails = $(this).attr("data-variant-detail");
    var variantSku = $(this).attr("data-variant-sku");
    var sectionId = $(this).attr("data-section-id");
    var variantPrice = parseFloat(variantDetails / 100);
    var variant = $(this).attr("data-variant") ? JSON.parse($(this).attr("data-variant")) : {};
    var regPrice = parseFloat(variant?.price)/100;
    var compareAtPrice = parseFloat(variant?.compare_at_price)/100;
    var vipPrice = $(this).attr("data-vip-price") ? parseFloat($(this).attr("data-vip-price")) : 0;
    var vvipPrice = $(this).attr("data-vvip-price") ? parseFloat($(this).attr("data-vvip-price")) : 0;
    var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
    var checkVisitingCustomerPrivateSale = localStorage.getItem("setVisitingCustomerPrivateSale");
    var salePrice = 0;
    var showPercentOff = false;
    var enableCompareAtPrice= false;
    
    /* Sale Price for All Visitors */
    if (showSalePriceGlobal && showSalePriceGlobal === true) {
      salePrice = $(this).attr("data-sale-price") ? parseFloat($(this).attr("data-sale-price")) : 0;
      showPercentOff = true;
      enableCompareAtPrice = true
    }
    /* Sale Price to show for VIP Visitors */
    if (showVIPPriceGlobal && showVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVIPParam) {
      salePrice = vipPrice;
      showPercentOff = true;
      enableCompareAtPrice = true
    }
    /* Sale Price to show for VVIP Visitors */
    if (showVVIPPriceGlobal && showVVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVVIPParam) {
      salePrice = vvipPrice;
      showPercentOff = true;
      enableCompareAtPrice = true
    }

    /* Locked Private Sale: Sale Price to show for VIP Visitors */
    if (showVIPPrivateSale && showVIPPrivateSale === true && checkVIPUser && checkVIPUser === true && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale === getVIPParamPrivateSale) {
      salePrice = vipPrice;
      showPercentOff = true;
      enableCompareAtPrice = true
    }
    /* Locked Private Sale: Sale Price to show for VVIP Visitors */
    if (showVVIPPrivateSale && showVVIPPrivateSale === true && checkVVIPUser && checkVVIPUser === true && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale === getVVIPParamPrivateSale) {
      salePrice = vvipPrice;
      showPercentOff = true;
      enableCompareAtPrice = true
    }

    var formattedSalePrice = salePrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    formattedSalePrice = formatPriceFunc(formattedSalePrice); /* Removing decimal if .00 found in the price */
    var formattedCompareAtPrice = compareAtPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    formattedCompareAtPrice = formatPriceFunc(formattedCompareAtPrice); /* Removing decimal if .00 found in the price */
    var formattedVariantPrice = variantPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    formattedVariantPrice = formatPriceFunc(formattedVariantPrice); /* Removing decimal if .00 found in the price */

    /* Discount percent Implementation */
    var percentageOff = ''
    if (showPercentOff == true) {
      percentageOff = (((regPrice - salePrice) / regPrice) * 100).toFixed(2)
      percentageOff = percentageOff.replace(/\.00$/, '') + "% off";
    }
    if (compareAtPrice && compareAtPrice != null && compareAtPrice > 0 && compareAtPrice > regPrice && enableCompareAtPrice == true) {
      percentageOff = (((compareAtPrice - regPrice) / compareAtPrice) * 100).toFixed(2)
      percentageOff = percentageOff.replace(/\.00$/, '') + "% off";
    }
    if ((salePrice != '' && salePrice > 0) || (compareAtPrice != null && compareAtPrice > 0)) {
      if (compareAtPrice && compareAtPrice > regPrice) {
        var startingAtText = $(this).parent().find(".upwardWrapper").text().includes("Starting at");
        var removeStartingAt = $(this).parent().find(".upwardWrapper").text().replace("Starting at", "");
        $(this).parent().find(".upwardWrapper").text(removeStartingAt);
        $(this).parent().find(".upwardWrapper").css("color", salePriceColorGlobal);
        $('.showSalePriceOnSearch').css("margin-bottom",'0px')
        if($(`#${variantId}_${sectionId}_${variantSku}_compareAt`).length === 0){
          $(`#${variantId}_${sectionId}_${variantSku}`).after('<div id="compare-at-'+ productId +'">' + (startingAtText ? '<span>Starting at</span>' : '') + '<span class="comapreAt strikeThrough" id="' + variantId + "_" + sectionId + "_" + variantSku + '_compareAt"> ' + "$" + formattedCompareAtPrice + '</span><span class="comapreAt" id="' + variantId + "_" + sectionId + "_" + variantSku + '_percentOff" style=color:' + showPercentageOffColorGlobal + '> ' + percentageOff + '</span></div>')
        }
        $(`#${variantId}_${sectionId}_${variantSku}`).parent().find('span.money').removeClass("strikeThrough").css("color", salePriceColorGlobal);
        $(`#${variantId}_${sectionId}_${variantSku}`).parent().addClass("textUpword-collection")
        if (checkAddonFlyout && checkAddonFlyout !== null) {
          var $container = $('.products-list-details.textUpword-collection');
          var $link = $container.find(`#change-position-${productId}`);
          var $compareAtDiv = $container.find(`#compare-at-${productId}`);
          $link.insertAfter($compareAtDiv);
        }
      } else {
        if (salePrice && salePrice < regPrice) {
          $(`#${variantId}_${sectionId}_${variantSku}`).html(`$${formattedSalePrice}`).css("color", salePriceColorGlobal);
          $(`#${variantId}_${sectionId}_${variantSku}`).parent().find('span.money').addClass('strikeThrough').css("color", "#000");
          if ($(`#${variantId}_${sectionId}_${variantSku}`).parent().find(`#${variantId}_${sectionId}_${variantSku}_percentOff`).length !== 0) {
            $(`#${variantId}_${sectionId}_${variantSku}`).parent().find(`#${variantId}_${sectionId}_${variantSku}_percentOff`).html(" " + percentageOff);
          } else {
            $(`#${variantId}_${sectionId}_${variantSku}`).parent().find('span.money').after('<span id="' + variantId + "_" + sectionId + "_" + variantSku + '_percentOff" style=color:' + showPercentageOffColorGlobal + '> ' + percentageOff + '</span>')
          }
          $(`#${variantId}_${sectionId}_${variantSku}`).parent().removeClass("textUpword-collection")
        }
      }
    }
  })
}

/* Enable Add to cart and Removing Disabled class */
function enableAddToCartButton() {
  var checkButtonText = $('.ProductForm__AddToCart').text().toLowerCase();
  if (checkButtonText.indexOf('sold out') > -1 && currentProductTemplate !== 'sold-out-er-build-your-ow' && currentProductTemplate !== 'sold-out-er-customize' && currentProductTemplate !== 'fluted-heart') {
    disableAddToCartButton();
    var buttonText = $('.ProductForm__AddToCart').text();
    if(buttonText.toLowerCase() === "sold out"){
      $('.ProductForm__AddToCart').text(buttonText);
    }
  } else {
    $(".ProductForm__AddToCart").prop('disabled', false);
  }
}

/* Disable Add to cart and Removing Disabled class */
function disableAddToCartButton() {
  $(".ProductForm__AddToCart").prop('disabled', true);
}

/* Charm builder scroll Functionality */
var targetPosition;
var scrollEnabledCalled = false;
function disableScroll() {
  // $('body').css('overflow', 'hidden');
  // $(window).on('scroll.prevent', function () {
  //     $(window).scrollTop(targetPosition);
  // });
}

function enableScroll() {
  if (!scrollEnabledCalled) {
    $('body').css('overflow', '');
    $(window).off('scroll.prevent');
    scrollEnabledCalled = true;
  }
}

let cleanOrphanGhostProductsRan = false;
async function cleanOrphanGhostProducts() {
  if (cleanOrphanGhostProductsRan) return; // already ran once
  cleanOrphanGhostProductsRan = true;
  
  const ENGRAVING_VARIANT_ID = 40218981892184; // dedicated engraving product variant ID
  const cart = await fetch('/cart.js').then(res => res.json());
  const items = cart.items;
  const variantIdsInCart = new Set(items.map(i => Number(i.variant_id)));
  const associatedKeysInCart = new Set();
  // Map of variant_id => [items]
  const itemsByVariantId = new Map();
  for (const item of items) {
    const id = Number(item.variant_id);
    if (!itemsByVariantId.has(id)) itemsByVariantId.set(id, []);
    itemsByVariantId.get(id).push(item);
  }

  // Track main products with engraving/stone/giftwrap
  const mainItemsNeedingEngraving = [];
  for (const item of items) {
    const props = item.properties || {};
    const isMain =
      props._engraving_required === "Yes" ||
      !!props._Custom_Stone_1 ||
      props._giftwrap === "true";

    if (isMain && props._associated_unique_key) {
      associatedKeysInCart.add(props._associated_unique_key);
      if (props._engraving_required === "Yes") {
        mainItemsNeedingEngraving.push(item);
      }
    }
  }

  console.log("🛒 Variant IDs in cart:", Array.from(variantIdsInCart));
  console.log("🔑 Associated keys from main products:", Array.from(associatedKeysInCart));

  const ghostItemKeysToRemove = [];
  const engravingGhostsToAdd = [];

  // STEP 1: Find orphan ghost products to remove
  for (const item of items) {
    const props = item.properties || {};
    const lineKey = item.key;
    const variantId = Number(item.variant_id);
    let isGhost = false;
    let isOrphan = false;
    const associatedKey = props._associated_unique_key;

    // ENGRAVING
    if (props._engrave_associated_var_id) {
      isGhost = true;
      const mainVarId = Number(props._engrave_associated_var_id);
      const keyMatch = associatedKeysInCart.has(associatedKey);
      if (!variantIdsInCart.has(mainVarId) || !keyMatch) {
        isOrphan = true;
        console.log(`✖ ENGRAVING orphan ghost: ${lineKey}`);
      }
    }
    // STONE
    else if (props._stone_associated_variant_id) {
      isGhost = true;
      const mainVarId = Number(props._stone_associated_variant_id);
      const keyMatch = associatedKeysInCart.has(associatedKey);
      if (!variantIdsInCart.has(mainVarId) || !keyMatch) {
        isOrphan = true;
        console.log(`✖ STONE orphan ghost: ${lineKey}`);
      }
    }
    // GIFT WRAP
    else if (props._associated_variant_id) {
      const mainVarId = Number(props._associated_variant_id);
      const mainItems = itemsByVariantId.get(mainVarId) || [];
      const isThisGhost = props._giftwrap !== "true";

      if (isThisGhost) {
        isGhost = true;
        const matchedMain = mainItems.find(mainItem =>
          mainItem.properties &&
          mainItem.properties._associated_unique_key === associatedKey &&
          mainItem.properties._giftwrap === "true"
        );
        if (!matchedMain) {
          isOrphan = true;
          console.log(`✖ GIFT WRAP orphan ghost: ${lineKey}`);
        }
      }
    }
    if (isGhost && isOrphan) {
      ghostItemKeysToRemove.push(lineKey);
    }
  }
  // STEP 2: Find missing engraving ghosts to add
  for (const mainItem of mainItemsNeedingEngraving) {
    const props = mainItem.properties || {};
    const assocKey = props._associated_unique_key;
    const hasEngravingGhost = items.some(i =>
      i.variant_id == ENGRAVING_VARIANT_ID &&
      i.properties &&
      i.properties._engrave_associated_var_id == mainItem.variant_id &&
      i.properties._associated_unique_key == assocKey
    );
    if (!hasEngravingGhost) {
      engravingGhostsToAdd.push({
        id: ENGRAVING_VARIANT_ID,
        quantity: mainItem.quantity,
        properties: {
          _engrave_associated_var_id: String(mainItem.variant_id),
          _associated_unique_key: assocKey
        }
      });
      console.log(`➕ Missing engraving ghost queued for add (main: ${mainItem.key})`);
    }
  }
  // STEP 3: Apply removals
  if (ghostItemKeysToRemove.length > 0) {
    console.log("🗑 Removing ghost items:", ghostItemKeysToRemove);
    const updates = {};
    ghostItemKeysToRemove.forEach(key => {
      updates[key] = 0;
    });
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }
  // STEP 4: Apply additions
  if (engravingGhostsToAdd.length > 0) {
    console.log("➕ Adding engraving ghosts:", engravingGhostsToAdd);
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: engravingGhostsToAdd })
    });
  }
  // STEP 5: Reload if any changes
  if (ghostItemKeysToRemove.length > 0 || engravingGhostsToAdd.length > 0) {
    if(window.location.pathname === '/cart'){
      setTimeout(() => {
        location.reload();
      }, 500);
    }
    console.log("🛒 Updated successfully.");
  } else {
    console.log("🚫 No orphan ghosts or missing engraving ghosts found.");
  }
}